/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any };
  /** Custom scalar for ExpandedState (true | Record<string, boolean>) */
  ExpandedState: { input: any; output: any };
  /** Custom scalar for unknown values */
  Unknown: { input: any; output: any };
  /** Custom scalar for VisibilityState (Record<string, boolean>) */
  VisibilityState: { input: any; output: any };
};

export type ActiveView = {
  __typename?: "ActiveView";
  columnFilters: Array<ColumnFilter>;
  columnOrder: Array<Scalars["String"]["output"]>;
  columnVisibility: Scalars["VisibilityState"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  expanded: Scalars["ExpandedState"]["output"];
  globalFilter: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  sectionColumnId?: Maybe<Scalars["String"]["output"]>;
  showColumnHeaders: Scalars["Boolean"]["output"];
  sorting: Array<ColumnSort>;
  subSectionColumnId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  userId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type Assignee = {
  __typename?: "Assignee";
  id: Scalars["String"]["output"];
  ownerId: Scalars["String"]["output"];
  ownerType: Scalars["String"]["output"];
  user: User;
  userId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type AuthEntity = {
  __typename?: "AuthEntity";
  token: Scalars["String"]["output"];
};

export type CheckPermissionInput = {
  /** The action to check permissions for */
  action: Scalars["String"]["input"];
  /** The type of resource to check permissions for */
  resource: Scalars["String"]["input"];
  /** Resource ID to check permissions for */
  resourceId: Scalars["String"]["input"];
};

export type CheckPermissionsInput = {
  /** List of permissions to check */
  permissions: Array<CheckPermissionInput>;
};

export type ClimateAction = {
  __typename?: "ClimateAction";
  assignee?: Maybe<Assignee>;
  children: Array<ClimateAction>;
  focusAreaInstance?: Maybe<FocusAreaInstance>;
  id: Scalars["String"]["output"];
  keyResult?: Maybe<KeyResult>;
  labelInstanceList: Array<LabelInstance>;
  parent?: Maybe<ClimateAction>;
  parentId?: Maybe<Scalars["String"]["output"]>;
  phaseInstance?: Maybe<PhaseInstance>;
  priority?: Maybe<PriorityInstance>;
  priorityInstance?: Maybe<PriorityInstance>;
  progressSnapshotList: Array<ProgressSnapshot>;
  properties?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<PhaseInstance>;
  teamInstanceList: Array<TeamInstance>;
  title: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type ColumnFilter = {
  __typename?: "ColumnFilter";
  id: Scalars["String"]["output"];
  value: Scalars["Unknown"]["output"];
};

export type ColumnFilterInput = {
  id: Scalars["String"]["input"];
  value: Scalars["Unknown"]["input"];
};

export type ColumnSort = {
  __typename?: "ColumnSort";
  desc: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
};

export type ColumnSortInput = {
  desc: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
};

export type CreateActiveViewInput = {
  columnFilters: Array<ColumnFilterInput>;
  columnOrder: Array<Scalars["String"]["input"]>;
  columnVisibility: Scalars["VisibilityState"]["input"];
  expanded: Scalars["ExpandedState"]["input"];
  globalFilter: Scalars["String"]["input"];
  key: Scalars["String"]["input"];
  sectionColumnId?: InputMaybe<Scalars["String"]["input"]>;
  showColumnHeaders: Scalars["Boolean"]["input"];
  sorting: Array<ColumnSortInput>;
  subSectionColumnId?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type CreateAssigneeInput = {
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateClimateActionInput = {
  parentId?: InputMaybe<Scalars["String"]["input"]>;
  properties?: InputMaybe<Scalars["String"]["input"]>;
  teamIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateFocusAreaInput = {
  color: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateFocusAreaInstanceInput = {
  focusAreaId: Scalars["String"]["input"];
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
};

export type CreateIndicatorInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  unitId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateIndicatorValueInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  date: Scalars["DateTime"]["input"];
  indicatorId: Scalars["String"]["input"];
  value: Scalars["Float"]["input"];
};

export type CreateKeyResultInput = {
  climateActionId: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  initialValue: Scalars["Float"]["input"];
  properties?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["DateTime"]["input"];
  targetDate: Scalars["DateTime"]["input"];
  targetValue: Scalars["Float"]["input"];
  title: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  unitId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateLabelGroupInput = {
  allowMultiSelect: Scalars["Boolean"]["input"];
  color: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateLabelInput = {
  color: Scalars["String"]["input"];
  labelGroupId?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateLabelInstanceInput = {
  labelId: Scalars["String"]["input"];
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  teamId?: InputMaybe<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type CreatePhaseInput = {
  color: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreatePhaseInstanceInput = {
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  phaseId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreatePriorityInput = {
  color: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreatePriorityInstanceInput = {
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  priorityId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateProgressSnapshotInput = {
  climateActionId: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  keyResultId?: InputMaybe<Scalars["String"]["input"]>;
  properties?: InputMaybe<Scalars["String"]["input"]>;
  snapshotDate: Scalars["DateTime"]["input"];
  status: Scalars["String"]["input"];
  value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateSavedViewInput = {
  /** Whether this is a base view that cannot be deleted */
  isBaseView?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether this should be the default view */
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Name of the view */
  name: Scalars["String"]["input"];
  /** JSON string containing table configurations */
  tableConfiguration: Scalars["String"]["input"];
  /** URL of the view */
  url: Scalars["String"]["input"];
  /** ID of the workspace */
  workspaceId: Scalars["ID"]["input"];
};

export type CreateTaskInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  position: Scalars["Int"]["input"];
  status: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
};

export type CreateTeamInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  logoType?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  visibility: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type CreateTeamInstanceInput = {
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  teamId: Scalars["String"]["input"];
};

export type CreateUnitInput = {
  symbol: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type DeleteAssigneeInput = {
  id: Scalars["String"]["input"];
};

export type DeleteClimateActionInput = {
  id: Scalars["String"]["input"];
};

export type DeleteFocusAreaInput = {
  id: Scalars["String"]["input"];
};

export type DeleteFocusAreaInstanceInput = {
  id: Scalars["String"]["input"];
};

export type DeleteIndicatorInput = {
  id: Scalars["String"]["input"];
};

export type DeleteIndicatorValueInput = {
  id: Scalars["String"]["input"];
};

export type DeleteKeyResultInput = {
  id: Scalars["String"]["input"];
};

export type DeleteLabelGroupInput = {
  id: Scalars["String"]["input"];
};

export type DeleteLabelInput = {
  id: Scalars["String"]["input"];
};

export type DeleteLabelInstanceInput = {
  id: Scalars["String"]["input"];
};

export type DeletePhaseInput = {
  id: Scalars["String"]["input"];
};

export type DeletePhaseInstanceInput = {
  id: Scalars["String"]["input"];
};

export type DeletePriorityInput = {
  id: Scalars["String"]["input"];
};

export type DeletePriorityInstanceInput = {
  id: Scalars["String"]["input"];
};

export type DeleteProgressSnapshotInput = {
  id: Scalars["String"]["input"];
};

export type DeleteSavedViewInput = {
  /** ID of the view to delete */
  id: Scalars["ID"]["input"];
};

export type DeleteTaskByIdInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteTeamInstanceInput = {
  id: Scalars["String"]["input"];
};

export type DeleteUnitInput = {
  id: Scalars["String"]["input"];
};

export type DownloadLink = {
  __typename?: "DownloadLink";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type DownloadLinkCreateInput = {
  fileId: Scalars["String"]["input"];
};

export type EmailEntity = {
  __typename?: "EmailEntity";
  email: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type EmailStatus = {
  __typename?: "EmailStatus";
  email: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type FeatureFlag = {
  __typename?: "FeatureFlag";
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  payload?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type FileCreateInput = {
  name: Scalars["String"]["input"];
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  url: Scalars["String"]["input"];
};

export type FileDeleteInput = {
  id: Scalars["String"]["input"];
};

export type FileGetInput = {
  id: Scalars["String"]["input"];
};

export type FileListGetByOwnerInput = {
  ownerId: Scalars["String"]["input"];
};

export type FileReplaceInput = {
  id: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type FileUpdateInput = {
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type FocusArea = {
  __typename?: "FocusArea";
  color: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  instanceList: Array<FocusAreaInstance>;
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type FocusAreaInstance = {
  __typename?: "FocusAreaInstance";
  focusArea: FocusArea;
  focusAreaId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  ownerId: Scalars["String"]["output"];
  ownerType: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type GetActiveViewInput = {
  key: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type GetActiveViewListInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetAllTaskListInput = {
  statusList?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GetAssigneeInput = {
  id: Scalars["String"]["input"];
};

export type GetAssigneeListByOwnerInput = {
  ownerId: Scalars["String"]["input"];
};

export type GetClimateActionInput = {
  id: Scalars["String"]["input"];
};

export type GetClimateActionListForTeamListInput = {
  teamIdList: Array<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type GetClimateActionListForWorkspaceInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetFeatureFlagInput = {
  id: Scalars["String"]["input"];
  refetch?: InputMaybe<Scalars["Boolean"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type GetFeatureFlagListInput = {
  refetch?: InputMaybe<Scalars["Boolean"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type GetFocusAreaInput = {
  id: Scalars["String"]["input"];
};

export type GetFocusAreaInstanceByOwnerInput = {
  ownerId: Scalars["String"]["input"];
};

export type GetFocusAreaInstanceInput = {
  id: Scalars["String"]["input"];
};

export type GetFocusAreaListForWorkspaceInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetIndicatorInput = {
  id: Scalars["String"]["input"];
};

export type GetIndicatorListInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetKeyResultInput = {
  id: Scalars["String"]["input"];
};

export type GetKeyResultsInput = {
  climateActionId: Scalars["String"]["input"];
};

export type GetLabelGroupInput = {
  id: Scalars["String"]["input"];
};

export type GetLabelGroupListForWorkspaceInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetLabelInput = {
  id: Scalars["String"]["input"];
};

export type GetLabelInstanceInput = {
  id: Scalars["String"]["input"];
};

export type GetLabelInstanceListInput = {
  ownerId: Scalars["String"]["input"];
};

export type GetLabelListForWorkspaceInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetPhaseInput = {
  id: Scalars["String"]["input"];
};

export type GetPhaseInstanceByOwnerInput = {
  ownerId: Scalars["String"]["input"];
};

export type GetPhaseInstanceInput = {
  id: Scalars["String"]["input"];
};

export type GetPhaseListForWorkspaceInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetPriorityInput = {
  id: Scalars["String"]["input"];
};

export type GetPriorityInstanceByOwnerInput = {
  ownerId: Scalars["String"]["input"];
};

export type GetPriorityInstanceInput = {
  id: Scalars["String"]["input"];
};

export type GetPriorityListForWorkspaceInput = {
  workspaceId: Scalars["String"]["input"];
};

export type GetProgressSnapshotInput = {
  id: Scalars["String"]["input"];
};

export type GetProgressSnapshotsForKeyResultInput = {
  keyResultId: Scalars["String"]["input"];
};

export type GetProgressSnapshotsInput = {
  climateActionId: Scalars["String"]["input"];
};

export type GetSavedViewsByUrlInput = {
  /** URL of the view */
  url: Scalars["String"]["input"];
  /** ID of the workspace */
  workspaceId: Scalars["ID"]["input"];
};

export type GetSavedViewsForWorkspaceInput = {
  /** ID of the workspace */
  workspaceId: Scalars["ID"]["input"];
};

export type GetTaskByIdInput = {
  id: Scalars["ID"]["input"];
};

export type GetTeamInstanceByOwnerInput = {
  ownerId: Scalars["String"]["input"];
};

export type GetTeamInstanceInput = {
  id: Scalars["String"]["input"];
};

export type GetUnitInput = {
  id: Scalars["String"]["input"];
};

export type GetUnitListInput = {
  workspaceId: Scalars["String"]["input"];
};

export type Indicator = {
  __typename?: "Indicator";
  createdAt: Scalars["DateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  latestValue?: Maybe<IndicatorValue>;
  title: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  valueCount: Scalars["Int"]["output"];
  values: Array<IndicatorValue>;
  workspaceId: Scalars["String"]["output"];
};

export type IndicatorValue = {
  __typename?: "IndicatorValue";
  comment?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  date: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  indicatorId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  value: Scalars["Float"]["output"];
};

export type KeyResult = {
  __typename?: "KeyResult";
  climateAction: ClimateAction;
  climateActionId: Scalars["String"]["output"];
  currentValue: Scalars["Float"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  initialValue: Scalars["Float"]["output"];
  properties?: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["DateTime"]["output"];
  targetDate: Scalars["DateTime"]["output"];
  targetValue: Scalars["Float"]["output"];
  title: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars["String"]["output"]>;
};

export type Label = {
  __typename?: "Label";
  color: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  instanceList: Array<LabelInstance>;
  labelGroup?: Maybe<LabelGroup>;
  labelGroupId?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type LabelGroup = {
  __typename?: "LabelGroup";
  allowMultiSelect: Scalars["Boolean"]["output"];
  color: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  labelList: Array<Label>;
  title: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type LabelInstance = {
  __typename?: "LabelInstance";
  id: Scalars["String"]["output"];
  label: Label;
  labelGroup?: Maybe<LabelGroup>;
  labelGroupId?: Maybe<Scalars["String"]["output"]>;
  labelId: Scalars["String"]["output"];
  ownerId: Scalars["String"]["output"];
  ownerType: Scalars["String"]["output"];
  teamId?: Maybe<Scalars["String"]["output"]>;
  workspaceId: Scalars["String"]["output"];
};

/** Describes the login input. */
export type LoginInput = {
  /** The email of the user. */
  email: Scalars["String"]["input"];
  /** The password of the user. */
  password: Scalars["String"]["input"];
};

export type MakeFileAccessibleToPublicInput = {
  fileName: Scalars["String"]["input"];
};

export type Mutation = {
  __typename?: "Mutation";
  acceptTeamInvite: TeamInvite;
  acceptWorkspaceInvite: WorkspaceInvite;
  checkPasswordResetToken: EmailEntity;
  /** Requires authentication with valid bearer token. */
  createActiveView: ActiveView;
  /** Requires authentication with valid bearer token. */
  createAssignee: Assignee;
  /** Create a new climate action */
  createClimateAction: ClimateAction;
  /** Requires authentication with valid bearer token. */
  createDownloadLink: DownloadLink;
  /** Requires authentication with valid bearer token. */
  createFile: MyFile;
  /** Requires authentication with valid bearer token. */
  createFocusArea: FocusArea;
  /** Requires authentication with valid bearer token. */
  createFocusAreaInstance: FocusAreaInstance;
  /** Requires authentication with valid bearer token. */
  createIndicator: Indicator;
  /** Requires authentication with valid bearer token. */
  createIndicatorValue: IndicatorValue;
  /** Requires authentication with valid bearer token. */
  createKeyResult: KeyResult;
  /** Requires authentication with valid bearer token. */
  createLabel: Label;
  /** Requires authentication with valid bearer token. */
  createLabelGroup: LabelGroup;
  /** Requires authentication with valid bearer token. */
  createLabelInstance: LabelInstance;
  /** Requires authentication with valid bearer token. */
  createPhase: Phase;
  /** Requires authentication with valid bearer token. */
  createPhaseInstance: PhaseInstance;
  /** Requires authentication with valid bearer token. */
  createPriority: Priority;
  /** Requires authentication with valid bearer token. */
  createPriorityInstance: PriorityInstance;
  /** Requires authentication with valid bearer token. */
  createProgressSnapshot: ProgressSnapshot;
  /** Create a new saved view. Requires authentication with valid bearer token. */
  createSavedView: SavedView;
  /** Requires authentication with valid bearer token. */
  createSignedUploadUrl: SignedUploadUrl;
  createTask: Task;
  /** Requires authentication with valid bearer token. */
  createTeam: Team;
  /** Requires authentication with valid bearer token. */
  createTeamInstance: TeamInstance;
  /** Requires authentication with valid bearer token. */
  createTeamInvite: TeamMembership;
  /** Requires authentication with valid bearer token. */
  createUnit: Unit;
  /** Requires authentication with valid bearer token. */
  createUserFavorite: UserFavorite;
  /** Requires authentication with valid bearer token. */
  createWorkspaceInvite: WorkspaceMembership;
  /** Requires authentication with valid bearer token. */
  deleteAssignee: Assignee;
  /** Delete a climate action */
  deleteClimateAction: ClimateAction;
  /** Requires authentication with valid bearer token. */
  deleteFile: MyFile;
  /** Requires authentication with valid bearer token. */
  deleteFocusArea: FocusArea;
  /** Requires authentication with valid bearer token. */
  deleteFocusAreaInstance: FocusAreaInstance;
  /** Requires authentication with valid bearer token. */
  deleteIndicator: Indicator;
  /** Requires authentication with valid bearer token. */
  deleteIndicatorValue: IndicatorValue;
  /** Requires authentication with valid bearer token. */
  deleteKeyResult: KeyResult;
  /** Requires authentication with valid bearer token. */
  deleteLabel: Label;
  /** Requires authentication with valid bearer token. */
  deleteLabelGroup: LabelGroup;
  /** Requires authentication with valid bearer token. */
  deleteLabelInstance: LabelInstance;
  /** Requires authentication with valid bearer token. */
  deletePhase: Phase;
  /** Requires authentication with valid bearer token. */
  deletePhaseInstance: PhaseInstance;
  /** Requires authentication with valid bearer token. */
  deletePriority: Priority;
  /** Requires authentication with valid bearer token. */
  deletePriorityInstance: PriorityInstance;
  /** Delete a progress snapshot */
  deleteProgressSnapshot: ProgressSnapshot;
  /** Delete a saved view. Requires authentication with valid bearer token. */
  deleteSavedView: SavedView;
  deleteTask: Task;
  /** Requires authentication with valid bearer token. */
  deleteTeamInstance: TeamInstance;
  deleteTeamInvite: TeamInvite;
  /** Delete a unit */
  deleteUnit: Unit;
  /** Requires authentication with valid bearer token. */
  deleteUserFavorite: UserFavorite;
  /** Requires authentication with valid bearer token. */
  deleteWorkspace: Workspace;
  /** Requires authentication with valid bearer token. */
  deleteWorkspaceInvitation: WorkspaceMembership;
  /** Requires authentication with valid bearer token. */
  joinTeam: TeamMembership;
  /** Requires authentication with valid bearer token. */
  leaveTeam: TeamMembership;
  /** Requires authentication with valid bearer token. */
  leaveWorkspaceMembership: WorkspaceMembership;
  login: AuthEntity;
  /** Requires authentication with valid bearer token. */
  makeFileAccessibleToPublic: Scalars["String"]["output"];
  /** Requires authentication with valid bearer token. */
  refresh: AuthEntity;
  /** Requires authentication with valid bearer token. */
  rejoinTeamMembership: TeamMembership;
  /** Requires authentication with valid bearer token. */
  rejoinWorkspaceMembership: WorkspaceMembership;
  /** Requires authentication with valid bearer token. */
  removeTeam: Team;
  /** Requires authentication with valid bearer token. */
  renameUserFavorite: UserFavorite;
  /** Requires authentication with valid bearer token. */
  replaceFile: MyFile;
  requestPasswordResetLink: EmailEntity;
  /** Requires authentication with valid bearer token. */
  resendTeamInviteNotification: TeamMembership;
  /** Requires authentication with valid bearer token. */
  resendWorkspaceInviteNotification: WorkspaceMembership;
  /** Requires authentication with valid bearer token. */
  sendWorkspaceDeleteCodeEmail: EmailStatus;
  /** Requires authentication with valid bearer token. */
  superuser_createTeam: Team;
  /** Requires authentication with valid bearer token and superUser privileges. */
  superuser_createTeamMembership: TeamMembership;
  /** Requires authentication with valid bearer token and superuser privileges. */
  superuser_createWorkspace: Workspace;
  /** Requires authentication with valid bearer token and superUser privileges. */
  superuser_createWorkspaceMembership: WorkspaceMembership;
  /** Requires authentication with valid bearer token and superUser privileges. */
  superuser_deleteTeamMembership: TeamMembership;
  /** Requires authentication with valid bearer token and superUser privileges. */
  superuser_deleteWorkspaceMembership: WorkspaceMembership;
  /** Requires authentication with valid bearer token and superuser privileges. */
  superuser_duplicateWorkspace: Workspace;
  /** Requires authentication with valid bearer token and superUser privileges. */
  superuser_updateTeamMembershipStatus: TeamMembership;
  /** Requires authentication with valid bearer token. */
  updateActiveView: ActiveView;
  /** Requires authentication with valid bearer token. */
  updateAssignee: Assignee;
  /** Update a climate action */
  updateClimateAction: ClimateAction;
  /** Requires authentication with valid bearer token. */
  updateFile: MyFile;
  /** Requires authentication with valid bearer token. */
  updateFocusArea: FocusArea;
  /** Requires authentication with valid bearer token. */
  updateFocusAreaInstance: FocusAreaInstance;
  /** Requires authentication with valid bearer token. */
  updateIndicator: Indicator;
  /** Requires authentication with valid bearer token. */
  updateIndicatorValue: IndicatorValue;
  /** Requires authentication with valid bearer token. */
  updateKeyResult: KeyResult;
  /** Requires authentication with valid bearer token. */
  updateLabel: Label;
  /** Requires authentication with valid bearer token. */
  updateLabelGroup: LabelGroup;
  /** Requires authentication with valid bearer token. */
  updatePassword: User;
  updatePasswordWithToken: EmailEntity;
  /** Requires authentication with valid bearer token. */
  updatePhase: Phase;
  /** Requires authentication with valid bearer token. */
  updatePhaseInstance: PhaseInstance;
  /** Requires authentication with valid bearer token. */
  updatePriority: Priority;
  /** Requires authentication with valid bearer token. */
  updatePriorityInstance: PriorityInstance;
  /** Requires authentication with valid bearer token. */
  updateProgressSnapshot: ProgressSnapshot;
  /** Update an existing saved view. Requires authentication with valid bearer token. */
  updateSavedView: SavedView;
  updateTask: Task;
  updateTaskList: Array<Task>;
  /** Requires authentication with valid bearer token. */
  updateTeam: Team;
  /** Requires authentication with valid bearer token. */
  updateTeamInstance: TeamInstance;
  /** Requires authentication with valid bearer token. */
  updateTeamInstanceListForOwner: Array<TeamInstance>;
  /** Requires authentication with valid bearer token. */
  updateTeamMembershipRole: TeamMembership;
  /** Requires authentication with valid bearer token. */
  updateTeamMembershipStatus: TeamMembership;
  /** Requires authentication with valid bearer token. */
  updateUnit: Unit;
  /** Requires authentication with valid bearer token. */
  updateUser: User;
  /** Requires authentication with valid bearer token. */
  updateWorkspace: Workspace;
  /** Requires authentication with valid bearer token. */
  updateWorkspaceMembershipRole: WorkspaceMembership;
  /** Requires authentication with valid bearer token. */
  updateWorkspaceMembershipStatus: WorkspaceMembership;
};

export type MutationAcceptTeamInviteArgs = {
  teamInviteAcceptInput: TeamInviteAcceptInput;
};

export type MutationAcceptWorkspaceInviteArgs = {
  workspaceInviteAcceptInput: WorkspaceInviteAcceptInput;
};

export type MutationCheckPasswordResetTokenArgs = {
  passwordResetTokenCheckInput: PasswordResetTokenCheckInput;
};

export type MutationCreateActiveViewArgs = {
  createActiveViewInput: CreateActiveViewInput;
};

export type MutationCreateAssigneeArgs = {
  createAssigneeInput: CreateAssigneeInput;
};

export type MutationCreateClimateActionArgs = {
  createClimateActionInput: CreateClimateActionInput;
};

export type MutationCreateDownloadLinkArgs = {
  downloadLinkCreateInput: DownloadLinkCreateInput;
};

export type MutationCreateFileArgs = {
  fileCreateInput: FileCreateInput;
};

export type MutationCreateFocusAreaArgs = {
  createFocusAreaInput: CreateFocusAreaInput;
};

export type MutationCreateFocusAreaInstanceArgs = {
  createFocusAreaInstanceInput: CreateFocusAreaInstanceInput;
};

export type MutationCreateIndicatorArgs = {
  createIndicatorInput: CreateIndicatorInput;
};

export type MutationCreateIndicatorValueArgs = {
  createIndicatorValueInput: CreateIndicatorValueInput;
};

export type MutationCreateKeyResultArgs = {
  createKeyResultInput: CreateKeyResultInput;
};

export type MutationCreateLabelArgs = {
  createLabelInput: CreateLabelInput;
};

export type MutationCreateLabelGroupArgs = {
  createLabelGroupInput: CreateLabelGroupInput;
};

export type MutationCreateLabelInstanceArgs = {
  createLabelInstanceInput: CreateLabelInstanceInput;
};

export type MutationCreatePhaseArgs = {
  createPhaseInput: CreatePhaseInput;
};

export type MutationCreatePhaseInstanceArgs = {
  createPhaseInstanceInput: CreatePhaseInstanceInput;
};

export type MutationCreatePriorityArgs = {
  createPriorityInput: CreatePriorityInput;
};

export type MutationCreatePriorityInstanceArgs = {
  createPriorityInstanceInput: CreatePriorityInstanceInput;
};

export type MutationCreateProgressSnapshotArgs = {
  createProgressSnapshotInput: CreateProgressSnapshotInput;
};

export type MutationCreateSavedViewArgs = {
  createSavedViewInput: CreateSavedViewInput;
};

export type MutationCreateSignedUploadUrlArgs = {
  signedUploadUrlCreateInput: SignedUploadUrlCreateInput;
};

export type MutationCreateTaskArgs = {
  createTaskInput: CreateTaskInput;
};

export type MutationCreateTeamArgs = {
  createTeamInput: CreateTeamInput;
};

export type MutationCreateTeamInstanceArgs = {
  createTeamInstanceInput: CreateTeamInstanceInput;
};

export type MutationCreateTeamInviteArgs = {
  teamInviteCreateInput: TeamInviteCreateInput;
};

export type MutationCreateUnitArgs = {
  createUnitInput: CreateUnitInput;
};

export type MutationCreateUserFavoriteArgs = {
  userFavoriteCreateInput: UserFavoriteCreateInput;
};

export type MutationCreateWorkspaceInviteArgs = {
  workspaceInviteCreateWithEmailInput: WorkspaceInviteCreateWithEmailInput;
};

export type MutationDeleteAssigneeArgs = {
  deleteAssigneeInput: DeleteAssigneeInput;
};

export type MutationDeleteClimateActionArgs = {
  deleteClimateActionInput: DeleteClimateActionInput;
};

export type MutationDeleteFileArgs = {
  fileDeleteInput: FileDeleteInput;
};

export type MutationDeleteFocusAreaArgs = {
  deleteFocusAreaInput: DeleteFocusAreaInput;
};

export type MutationDeleteFocusAreaInstanceArgs = {
  deleteFocusAreaInstanceInput: DeleteFocusAreaInstanceInput;
};

export type MutationDeleteIndicatorArgs = {
  deleteIndicatorInput: DeleteIndicatorInput;
};

export type MutationDeleteIndicatorValueArgs = {
  deleteIndicatorValueInput: DeleteIndicatorValueInput;
};

export type MutationDeleteKeyResultArgs = {
  deleteKeyResultInput: DeleteKeyResultInput;
};

export type MutationDeleteLabelArgs = {
  deleteLabelInput: DeleteLabelInput;
};

export type MutationDeleteLabelGroupArgs = {
  deleteLabelGroupInput: DeleteLabelGroupInput;
};

export type MutationDeleteLabelInstanceArgs = {
  deleteLabelInstanceInput: DeleteLabelInstanceInput;
};

export type MutationDeletePhaseArgs = {
  deletePhaseInput: DeletePhaseInput;
};

export type MutationDeletePhaseInstanceArgs = {
  deletePhaseInstanceInput: DeletePhaseInstanceInput;
};

export type MutationDeletePriorityArgs = {
  deletePriorityInput: DeletePriorityInput;
};

export type MutationDeletePriorityInstanceArgs = {
  deletePriorityInstanceInput: DeletePriorityInstanceInput;
};

export type MutationDeleteProgressSnapshotArgs = {
  deleteProgressSnapshotInput: DeleteProgressSnapshotInput;
};

export type MutationDeleteSavedViewArgs = {
  input: DeleteSavedViewInput;
};

export type MutationDeleteTaskArgs = {
  deleteTaskByIdInput: DeleteTaskByIdInput;
};

export type MutationDeleteTeamInstanceArgs = {
  deleteTeamInstanceInput: DeleteTeamInstanceInput;
};

export type MutationDeleteTeamInviteArgs = {
  teamInviteDeleteInput: TeamInviteDeleteInput;
};

export type MutationDeleteUnitArgs = {
  deleteUnitInput: DeleteUnitInput;
};

export type MutationDeleteUserFavoriteArgs = {
  userFavoriteDeleteInput: UserFavoriteDeleteInput;
};

export type MutationDeleteWorkspaceArgs = {
  workspaceDeleteInput: WorkspaceDeleteInput;
};

export type MutationDeleteWorkspaceInvitationArgs = {
  workspaceInviteDeleteInput: WorkspaceInviteDeleteInput;
};

export type MutationJoinTeamArgs = {
  teamMembershipJoinInput: TeamMembershipJoinInput;
};

export type MutationLeaveTeamArgs = {
  teamMembershipLeaveInput: TeamMembershipLeaveInput;
};

export type MutationLeaveWorkspaceMembershipArgs = {
  workspaceMembershipLeaveInput: WorkspaceMembershipLeaveInput;
};

export type MutationLoginArgs = {
  loginInput: LoginInput;
};

export type MutationMakeFileAccessibleToPublicArgs = {
  makeFileAccessibleToPublicInput: MakeFileAccessibleToPublicInput;
};

export type MutationRejoinTeamMembershipArgs = {
  teamMembershipRejoinInput: TeamMembershipRejoinInput;
};

export type MutationRejoinWorkspaceMembershipArgs = {
  workspaceMembershipRejoinInput: WorkspaceMembershipRejoinInput;
};

export type MutationRemoveTeamArgs = {
  token: Scalars["String"]["input"];
};

export type MutationRenameUserFavoriteArgs = {
  userFavoriteRenameInput: UserFavoriteRenameInput;
};

export type MutationReplaceFileArgs = {
  fileReplaceInput: FileReplaceInput;
};

export type MutationRequestPasswordResetLinkArgs = {
  passwordResetLinkRequestInput: PasswordResetLinkRequestInput;
};

export type MutationResendTeamInviteNotificationArgs = {
  teamInviteUpdateInput: TeamInviteUpdateInput;
};

export type MutationResendWorkspaceInviteNotificationArgs = {
  workspaceInviteUpdateInput: WorkspaceInviteUpdateInput;
};

export type MutationSendWorkspaceDeleteCodeEmailArgs = {
  workspaceDeleteCodeCreateInput: WorkspaceDeleteCodeCreateInput;
};

export type MutationSuperuser_CreateTeamArgs = {
  createTeamInput: CreateTeamInput;
};

export type MutationSuperuser_CreateTeamMembershipArgs = {
  teamMembershipCreateInput: TeamMembershipCreateInput;
};

export type MutationSuperuser_CreateWorkspaceArgs = {
  workspaceCreateInput: WorkspaceCreateInput;
};

export type MutationSuperuser_CreateWorkspaceMembershipArgs = {
  workspaceMembershipCreateInput: WorkspaceMembershipCreateInput;
};

export type MutationSuperuser_DeleteTeamMembershipArgs = {
  teamMembershipDeleteInput: TeamMembershipDeleteInput;
};

export type MutationSuperuser_DeleteWorkspaceMembershipArgs = {
  workspaceMembershipDeleteInput: WorkspaceMembershipDeleteInput;
};

export type MutationSuperuser_DuplicateWorkspaceArgs = {
  workspaceDuplicateInput: WorkspaceDuplicateInput;
};

export type MutationSuperuser_UpdateTeamMembershipStatusArgs = {
  teamMembershipUpdateStatusInput: TeamMembershipUpdateStatusInput;
};

export type MutationUpdateActiveViewArgs = {
  updateActiveViewInput: UpdateActiveViewInput;
};

export type MutationUpdateAssigneeArgs = {
  updateAssigneeInput: UpdateAssigneeInput;
};

export type MutationUpdateClimateActionArgs = {
  updateClimateActionInput: UpdateClimateActionInput;
};

export type MutationUpdateFileArgs = {
  fileUpdateInput: FileUpdateInput;
};

export type MutationUpdateFocusAreaArgs = {
  updateFocusAreaInput: UpdateFocusAreaInput;
};

export type MutationUpdateFocusAreaInstanceArgs = {
  updateFocusAreaInstanceInput: UpdateFocusAreaInstanceInput;
};

export type MutationUpdateIndicatorArgs = {
  updateIndicatorInput: UpdateIndicatorInput;
};

export type MutationUpdateIndicatorValueArgs = {
  updateIndicatorValueInput: UpdateIndicatorValueInput;
};

export type MutationUpdateKeyResultArgs = {
  updateKeyResultInput: UpdateKeyResultInput;
};

export type MutationUpdateLabelArgs = {
  updateLabelInput: UpdateLabelInput;
};

export type MutationUpdateLabelGroupArgs = {
  updateLabelGroupInput: UpdateLabelGroupInput;
};

export type MutationUpdatePasswordArgs = {
  passwordUpdateInput: PasswordUpdateInput;
};

export type MutationUpdatePasswordWithTokenArgs = {
  passwordUpdateWithTokenInput: PasswordUpdateWithTokenInput;
};

export type MutationUpdatePhaseArgs = {
  updatePhaseInput: UpdatePhaseInput;
};

export type MutationUpdatePhaseInstanceArgs = {
  updatePhaseInstanceInput: UpdatePhaseInstanceInput;
};

export type MutationUpdatePriorityArgs = {
  updatePriorityInput: UpdatePriorityInput;
};

export type MutationUpdatePriorityInstanceArgs = {
  updatePriorityInstanceInput: UpdatePriorityInstanceInput;
};

export type MutationUpdateProgressSnapshotArgs = {
  updateProgressSnapshotInput: UpdateProgressSnapshotInput;
};

export type MutationUpdateSavedViewArgs = {
  updateSavedViewInput: UpdateSavedViewInput;
};

export type MutationUpdateTaskArgs = {
  updateTaskInput: UpdateTaskInput;
};

export type MutationUpdateTaskListArgs = {
  updateTaskListInput: UpdateTaskListInput;
};

export type MutationUpdateTeamArgs = {
  updateTeamInput: UpdateTeamInput;
};

export type MutationUpdateTeamInstanceArgs = {
  updateTeamInstanceInput: UpdateTeamInstanceInput;
};

export type MutationUpdateTeamInstanceListForOwnerArgs = {
  updateTeamInstanceListForOwnerInput: UpdateTeamInstanceListForOwnerInput;
};

export type MutationUpdateTeamMembershipRoleArgs = {
  teamMembershipUpdateRoleInput: TeamMembershipUpdateRoleInput;
};

export type MutationUpdateTeamMembershipStatusArgs = {
  teamMembershipUpdateStatusInput: TeamMembershipUpdateStatusInput;
};

export type MutationUpdateUnitArgs = {
  updateUnitInput: UpdateUnitInput;
};

export type MutationUpdateUserArgs = {
  userUpdateInput: UserUpdateInput;
};

export type MutationUpdateWorkspaceArgs = {
  workspaceUpdateInput: WorkspaceUpdateInput;
};

export type MutationUpdateWorkspaceMembershipRoleArgs = {
  workspaceMembershipUpdateRoleInput: WorkspaceMembershipUpdateRoleInput;
};

export type MutationUpdateWorkspaceMembershipStatusArgs = {
  workspaceMembershipUpdateStatusInput: WorkspaceMembershipUpdateStatusInput;
};

export type MyFile = {
  __typename?: "MyFile";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  ownerId: Scalars["String"]["output"];
  ownerType: Scalars["String"]["output"];
  size: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Describes the input to request a password reset link. */
export type PasswordResetLinkRequestInput = {
  /** The email of the user. */
  email: Scalars["String"]["input"];
};

/** Describes the input to request to check whether a password reset token is valid. */
export type PasswordResetTokenCheckInput = {
  /** The password reset token. */
  token: Scalars["String"]["input"];
};

/** Describes the input to assign a new password to a user with the old password being known. */
export type PasswordUpdateInput = {
  /** The email of the user account. */
  email: Scalars["String"]["input"];
  /** The new password of the user. */
  newPassword: Scalars["String"]["input"];
  /** The current password of the user. */
  password: Scalars["String"]["input"];
};

/** Describes the input to assign a new password to a user with a password reset token. */
export type PasswordUpdateWithTokenInput = {
  /** The new password of the user. */
  password: Scalars["String"]["input"];
  /** The password reset token. */
  token: Scalars["String"]["input"];
};

export type PermissionResult = {
  __typename?: "PermissionResult";
  hasPermission: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
};

export type Phase = {
  __typename?: "Phase";
  color: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  instanceList: Array<PhaseInstance>;
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type PhaseInstance = {
  __typename?: "PhaseInstance";
  id: Scalars["String"]["output"];
  ownerId: Scalars["String"]["output"];
  ownerType: Scalars["String"]["output"];
  phase: Phase;
  phaseId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type Priority = {
  __typename?: "Priority";
  color: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  instanceList: Array<PriorityInstance>;
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type PriorityInstance = {
  __typename?: "PriorityInstance";
  id: Scalars["String"]["output"];
  ownerId: Scalars["String"]["output"];
  ownerType: Scalars["String"]["output"];
  priority: Priority;
  priorityId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type ProgressSnapshot = {
  __typename?: "ProgressSnapshot";
  climateAction: ClimateAction;
  climateActionId: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  keyResult?: Maybe<KeyResult>;
  keyResultId?: Maybe<Scalars["String"]["output"]>;
  properties?: Maybe<Scalars["String"]["output"]>;
  snapshotDate: Scalars["DateTime"]["output"];
  status: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  /** Get the activeView for a table key for a user in a workspace */
  activeView?: Maybe<ActiveView>;
  /** Get the activeViewList for a workspace */
  activeViewList: Array<ActiveView>;
  /** Requires authentication with valid bearer token. */
  activeWorkspaceMembershipListForWorkspace: Array<WorkspaceMembership>;
  /** Requires authentication with valid bearer token. */
  assignee: Assignee;
  /** Requires authentication with valid bearer token. */
  assigneeByOwner?: Maybe<Assignee>;
  /** Check if the authenticated user has permission to perform an action on a resource. Requires authentication with valid bearer token. */
  checkPermission: PermissionResult;
  /** Check if the authenticated user has permissions to perform multiple actions on resources. Requires authentication with valid bearer token. */
  checkPermissionList: Array<PermissionResult>;
  /** Get a single climate action by id */
  climateAction: ClimateAction;
  /** Get all climate actions for a list of teams */
  climateActionListForTeamList: Array<ClimateAction>;
  /** Get all climate actions for a workspace */
  climateActionListForWorkspace: Array<ClimateAction>;
  /** Requires authentication with valid bearer token. */
  currentUser: User;
  featureFlag?: Maybe<FeatureFlag>;
  featureFlagList: Array<FeatureFlag>;
  /** Requires authentication with valid bearer token. */
  file: MyFile;
  /** Requires authentication with valid bearer token. */
  fileListForOwner: Array<MyFile>;
  findTeamInvite: TeamInvite;
  findWorkspaceInvite: WorkspaceInvite;
  /** Requires authentication with valid bearer token. */
  focusArea: FocusArea;
  /** Requires authentication with valid bearer token. */
  focusAreaInstance: FocusAreaInstance;
  /** Requires authentication with valid bearer token. */
  focusAreaInstanceByOwner?: Maybe<FocusAreaInstance>;
  /** Requires authentication with valid bearer token. */
  focusAreaListForWorkspace: Array<FocusArea>;
  getAllTasks: Array<Task>;
  getTask: Task;
  /** Requires authentication with valid bearer token. */
  getUserFavoriteList: Array<UserFavorite>;
  /** Requires authentication with valid bearer token. */
  indicator: Indicator;
  /** Get all indicators for a workspace */
  indicatorList: Array<Indicator>;
  /** Requires authentication with valid bearer token. */
  keyResult: KeyResult;
  /** Requires authentication with valid bearer token. */
  keyResults: Array<KeyResult>;
  /** Get a label by id */
  label: Label;
  /** Get a label group by id */
  labelGroup: LabelGroup;
  /** Get all label groups for a workspace */
  labelGroupListForWorkspace: Array<LabelGroup>;
  /** Get a label instance by id */
  labelInstance: LabelInstance;
  /** Requires authentication with valid bearer token. */
  labelInstanceList: Array<LabelInstance>;
  /** Get the label list for a workspace */
  labelListForWorkspace: Array<Label>;
  /** Requires authentication with valid bearer token. */
  phase: Phase;
  /** Requires authentication with valid bearer token. */
  phaseInstance: PhaseInstance;
  /** Requires authentication with valid bearer token. */
  phaseInstanceByOwner?: Maybe<PhaseInstance>;
  /** Requires authentication with valid bearer token. */
  phaseListForWorkspace: Array<Phase>;
  /** Requires authentication with valid bearer token. */
  priority: Priority;
  /** Requires authentication with valid bearer token. */
  priorityInstance: PriorityInstance;
  /** Requires authentication with valid bearer token. */
  priorityInstanceByOwner?: Maybe<PriorityInstance>;
  /** Get the priority list for a workspace */
  priorityListForWorkspace: Array<Priority>;
  /** Requires authentication with valid bearer token. */
  progressSnapshot: ProgressSnapshot;
  /** Requires authentication with valid bearer token. */
  progressSnapshots: Array<ProgressSnapshot>;
  /** Requires authentication with valid bearer token. */
  progressSnapshotsForKeyResult: Array<ProgressSnapshot>;
  /** Requires authentication with valid bearer token. */
  requestTeamDeletionCode: EmailStatus;
  /** Get all saved views for a user in a workspace. Requires authentication with valid bearer token. */
  savedViewListForWorkspace: Array<SavedView>;
  /** Get all saved views for a user. Requires authentication with valid bearer token. */
  savedViews: Array<SavedView>;
  /** Requires authentication with valid bearer token and superuser privileges. */
  superuser_teamList: Array<Team>;
  /** Requires authentication with valid bearer token and superuser privileges. */
  superuser_teamListForWorkspace: Array<Team>;
  /** Requires authentication with valid bearer token and superuser privileges. */
  superuser_workspaceList: Array<Workspace>;
  /** Requires authentication with valid bearer token. */
  teamById: Team;
  /** Requires authentication with valid bearer token. */
  teamInstance: TeamInstance;
  /** Requires authentication with valid bearer token. */
  teamInstanceByOwner?: Maybe<TeamInstance>;
  /** Requires authentication with valid bearer token. */
  teamListForWorkspace: Array<Team>;
  /** Requires authentication with valid bearer token. */
  teamMembership: TeamMembership;
  /** Requires authentication with valid bearer token. */
  teamMembershipList: Array<TeamMembership>;
  /** Requires authentication with valid bearer token. */
  unit: Unit;
  /** Requires authentication with valid bearer token. */
  unitList: Array<Unit>;
  /** Requires authentication with valid bearer token. */
  userInWorkspace: User;
  /** Requires authentication with valid bearer token. */
  workspaceById: Workspace;
  /** Requires authentication with valid bearer token. */
  workspaceByUrl: Workspace;
  /** Requires authentication with valid bearer token. */
  workspaceMembership: WorkspaceMembership;
  /** Requires authentication with valid bearer token. */
  workspaceMembershipListForWorkspace: Array<WorkspaceMembership>;
};

export type QueryActiveViewArgs = {
  getActiveViewInput: GetActiveViewInput;
};

export type QueryActiveViewListArgs = {
  getActiveViewListInput: GetActiveViewListInput;
};

export type QueryActiveWorkspaceMembershipListForWorkspaceArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryAssigneeArgs = {
  getAssigneeInput: GetAssigneeInput;
};

export type QueryAssigneeByOwnerArgs = {
  getAssigneeListByOwnerInput: GetAssigneeListByOwnerInput;
};

export type QueryCheckPermissionArgs = {
  checkPermissionInput: CheckPermissionInput;
};

export type QueryCheckPermissionListArgs = {
  checkPermissionsInput: CheckPermissionsInput;
};

export type QueryClimateActionArgs = {
  getClimateActionInput: GetClimateActionInput;
};

export type QueryClimateActionListForTeamListArgs = {
  getClimateActionListForTeamListInput: GetClimateActionListForTeamListInput;
};

export type QueryClimateActionListForWorkspaceArgs = {
  getClimateActionListForWorkspaceInput: GetClimateActionListForWorkspaceInput;
};

export type QueryFeatureFlagArgs = {
  getFeatureFlagInput: GetFeatureFlagInput;
};

export type QueryFeatureFlagListArgs = {
  getFeatureFlagListInput: GetFeatureFlagListInput;
};

export type QueryFileArgs = {
  fileGetInput: FileGetInput;
};

export type QueryFileListForOwnerArgs = {
  fileListGetByOwnerInput: FileListGetByOwnerInput;
};

export type QueryFindTeamInviteArgs = {
  token: Scalars["String"]["input"];
};

export type QueryFindWorkspaceInviteArgs = {
  token: Scalars["String"]["input"];
};

export type QueryFocusAreaArgs = {
  getFocusAreaInput: GetFocusAreaInput;
};

export type QueryFocusAreaInstanceArgs = {
  getFocusAreaInstanceInput: GetFocusAreaInstanceInput;
};

export type QueryFocusAreaInstanceByOwnerArgs = {
  getFocusAreaInstanceByOwnerInput: GetFocusAreaInstanceByOwnerInput;
};

export type QueryFocusAreaListForWorkspaceArgs = {
  getFocusAreaListForWorkspaceInput: GetFocusAreaListForWorkspaceInput;
};

export type QueryGetAllTasksArgs = {
  getAllTaskListForUserInput?: InputMaybe<GetAllTaskListInput>;
};

export type QueryGetTaskArgs = {
  getTaskByIdInput: GetTaskByIdInput;
};

export type QueryGetUserFavoriteListArgs = {
  getUserFavoriteListInput: UserFavoriteGetInput;
};

export type QueryIndicatorArgs = {
  getIndicatorInput: GetIndicatorInput;
};

export type QueryIndicatorListArgs = {
  getIndicatorListInput: GetIndicatorListInput;
};

export type QueryKeyResultArgs = {
  getKeyResultInput: GetKeyResultInput;
};

export type QueryKeyResultsArgs = {
  getKeyResultsInput: GetKeyResultsInput;
};

export type QueryLabelArgs = {
  getLabelInput: GetLabelInput;
};

export type QueryLabelGroupArgs = {
  getLabelGroupInput: GetLabelGroupInput;
};

export type QueryLabelGroupListForWorkspaceArgs = {
  getLabelGroupListForWorkspaceInput: GetLabelGroupListForWorkspaceInput;
};

export type QueryLabelInstanceArgs = {
  getLabelInstanceInput: GetLabelInstanceInput;
};

export type QueryLabelInstanceListArgs = {
  getLabelInstanceListInput: GetLabelInstanceListInput;
};

export type QueryLabelListForWorkspaceArgs = {
  getLabelListForWorkspaceInput: GetLabelListForWorkspaceInput;
};

export type QueryPhaseArgs = {
  getPhaseInput: GetPhaseInput;
};

export type QueryPhaseInstanceArgs = {
  getPhaseInstanceInput: GetPhaseInstanceInput;
};

export type QueryPhaseInstanceByOwnerArgs = {
  getPhaseInstanceByOwnerInput: GetPhaseInstanceByOwnerInput;
};

export type QueryPhaseListForWorkspaceArgs = {
  getPhaseListForWorkspaceInput: GetPhaseListForWorkspaceInput;
};

export type QueryPriorityArgs = {
  getPriorityInput: GetPriorityInput;
};

export type QueryPriorityInstanceArgs = {
  getPriorityInstanceInput: GetPriorityInstanceInput;
};

export type QueryPriorityInstanceByOwnerArgs = {
  getPriorityInstanceByOwnerInput: GetPriorityInstanceByOwnerInput;
};

export type QueryPriorityListForWorkspaceArgs = {
  getPriorityListForWorkspaceInput: GetPriorityListForWorkspaceInput;
};

export type QueryProgressSnapshotArgs = {
  getProgressSnapshotInput: GetProgressSnapshotInput;
};

export type QueryProgressSnapshotsArgs = {
  getProgressSnapshotsInput: GetProgressSnapshotsInput;
};

export type QueryProgressSnapshotsForKeyResultArgs = {
  getProgressSnapshotsForKeyResultInput: GetProgressSnapshotsForKeyResultInput;
};

export type QueryRequestTeamDeletionCodeArgs = {
  updateTeamInput: UpdateTeamInput;
};

export type QuerySavedViewListForWorkspaceArgs = {
  getSavedViewsForWorkspaceInput: GetSavedViewsForWorkspaceInput;
};

export type QuerySavedViewsArgs = {
  getSavedViewsByUrlInput: GetSavedViewsByUrlInput;
};

export type QuerySuperuser_TeamListForWorkspaceArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryTeamByIdArgs = {
  teamId: Scalars["String"]["input"];
};

export type QueryTeamInstanceArgs = {
  getTeamInstanceInput: GetTeamInstanceInput;
};

export type QueryTeamInstanceByOwnerArgs = {
  getTeamInstanceByOwnerInput: GetTeamInstanceByOwnerInput;
};

export type QueryTeamListForWorkspaceArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryTeamMembershipArgs = {
  teamMembershipGetInput: TeamMembershipGetInput;
};

export type QueryTeamMembershipListArgs = {
  teamId: Scalars["String"]["input"];
};

export type QueryUnitArgs = {
  getUnitInput: GetUnitInput;
};

export type QueryUnitListArgs = {
  getUnitListInput: GetUnitListInput;
};

export type QueryUserInWorkspaceArgs = {
  userGetInput: UserGetInput;
};

export type QueryWorkspaceByIdArgs = {
  workspaceId: Scalars["String"]["input"];
};

export type QueryWorkspaceByUrlArgs = {
  workspaceUrl: Scalars["String"]["input"];
};

export type QueryWorkspaceMembershipArgs = {
  workspaceMembershipGetInput: WorkspaceMembershipGetInput;
};

export type QueryWorkspaceMembershipListForWorkspaceArgs = {
  workspaceId: Scalars["String"]["input"];
};

/** A saved view configuration */
export type SavedView = {
  __typename?: "SavedView";
  id: Scalars["ID"]["output"];
  /** Whether this is a base view that cannot be deleted */
  isBaseView: Scalars["Boolean"]["output"];
  /** Whether this is the default view */
  isDefault: Scalars["Boolean"]["output"];
  /** Name of the saved view */
  name: Scalars["String"]["output"];
  /** JSON string containing table tableConfiguration */
  tableConfiguration: Scalars["String"]["output"];
  /** URL of the saved view */
  url: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
  workspaceId: Scalars["ID"]["output"];
};

export type SignedUploadUrl = {
  __typename?: "SignedUploadUrl";
  permaUrl: Scalars["String"]["output"];
  signedUrl: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type SignedUploadUrlCreateInput = {
  fileExtension: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

export type Task = {
  __typename?: "Task";
  createdAt: Scalars["DateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  position: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  userId: Scalars["ID"]["output"];
};

export type Team = {
  __typename?: "Team";
  color?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  logo?: Maybe<Scalars["String"]["output"]>;
  logoType?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  teamMembershipList: Array<TeamMembership>;
  visibility: Scalars["String"]["output"];
  workspace: Workspace;
  workspaceId: Scalars["String"]["output"];
};

export type TeamInstance = {
  __typename?: "TeamInstance";
  id: Scalars["String"]["output"];
  ownerId: Scalars["String"]["output"];
  ownerType: Scalars["String"]["output"];
  team: Team;
  teamId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type TeamInvite = {
  __typename?: "TeamInvite";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  pendingWorkspaceMembership: Scalars["Boolean"]["output"];
  role: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  team?: Maybe<Team>;
  teamId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user?: Maybe<User>;
  userId: Scalars["String"]["output"];
};

export type TeamInviteAcceptInput = {
  token: Scalars["String"]["input"];
};

export type TeamInviteCreateInput = {
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamInviteDeleteInput = {
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamInviteUpdateInput = {
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamMembership = {
  __typename?: "TeamMembership";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  role: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  team?: Maybe<Team>;
  teamId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user?: Maybe<User>;
  userId: Scalars["String"]["output"];
};

export type TeamMembershipCreateInput = {
  role: Scalars["String"]["input"];
  status?: InputMaybe<Scalars["String"]["input"]>;
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamMembershipDeleteInput = {
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamMembershipGetInput = {
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamMembershipJoinInput = {
  teamId: Scalars["String"]["input"];
};

export type TeamMembershipLeaveInput = {
  teamId: Scalars["String"]["input"];
};

export type TeamMembershipRejoinInput = {
  teamId: Scalars["String"]["input"];
};

export type TeamMembershipUpdateRoleInput = {
  role: Scalars["String"]["input"];
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamMembershipUpdateStatusInput = {
  status: Scalars["String"]["input"];
  teamId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type Unit = {
  __typename?: "Unit";
  id: Scalars["String"]["output"];
  keyResults: Array<KeyResult>;
  symbol: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type UpdateActiveViewInput = {
  columnFilters?: InputMaybe<Array<ColumnFilterInput>>;
  columnOrder?: InputMaybe<Array<Scalars["String"]["input"]>>;
  columnVisibility?: InputMaybe<Scalars["VisibilityState"]["input"]>;
  expanded?: InputMaybe<Scalars["ExpandedState"]["input"]>;
  globalFilter?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  sectionColumnId?: InputMaybe<Scalars["String"]["input"]>;
  showColumnHeaders?: InputMaybe<Scalars["Boolean"]["input"]>;
  sorting?: InputMaybe<Array<ColumnSortInput>>;
  subSectionColumnId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAssigneeInput = {
  id: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type UpdateClimateActionInput = {
  id: Scalars["String"]["input"];
  parentId?: InputMaybe<Scalars["String"]["input"]>;
  properties?: InputMaybe<Scalars["String"]["input"]>;
  teamIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFocusAreaInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFocusAreaInstanceInput = {
  focusAreaId: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type UpdateIndicatorInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  unitId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateIndicatorValueInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  id: Scalars["String"]["input"];
  value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateKeyResultInput = {
  currentValue?: InputMaybe<Scalars["Float"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  initialValue?: InputMaybe<Scalars["Float"]["input"]>;
  properties?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  targetDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  targetValue?: InputMaybe<Scalars["Float"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  unitId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateLabelGroupInput = {
  allowMultiSelect?: InputMaybe<Scalars["Boolean"]["input"]>;
  color?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateLabelInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  labelGroupId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePhaseInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePhaseInstanceInput = {
  id: Scalars["String"]["input"];
  phaseId: Scalars["String"]["input"];
};

export type UpdatePriorityInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePriorityInstanceInput = {
  id: Scalars["String"]["input"];
  priorityId: Scalars["String"]["input"];
};

export type UpdateProgressSnapshotInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  keyResultId?: InputMaybe<Scalars["String"]["input"]>;
  properties?: InputMaybe<Scalars["String"]["input"]>;
  snapshotDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateSavedViewInput = {
  /** ID of the view to update */
  id: Scalars["ID"]["input"];
  /** Whether this is a base view that cannot be deleted */
  isBaseView?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether this should be the default view */
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** New name for the view */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** New table configuration or table configurations */
  tableConfiguration?: InputMaybe<Scalars["String"]["input"]>;
  /** URL of the view */
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTaskInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  position?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTaskListInput = {
  taskList: Array<UpdateTaskInput>;
};

export type UpdateTeamInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  logo?: InputMaybe<Scalars["String"]["input"]>;
  logoType?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  visibility?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTeamInstanceInput = {
  id: Scalars["String"]["input"];
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  teamId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type UpdateTeamInstanceListForOwnerInput = {
  ownerId: Scalars["String"]["input"];
  ownerType: Scalars["String"]["input"];
  teamIdList: Array<Scalars["String"]["input"]>;
  workspaceId: Scalars["String"]["input"];
};

export type UpdateUnitInput = {
  id: Scalars["String"]["input"];
  symbol?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type User = {
  __typename?: "User";
  activated: Scalars["Boolean"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  fullname?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  profilePicture?: Maybe<Scalars["String"]["output"]>;
  superUser: Scalars["Boolean"]["output"];
  teamMembershipList?: Maybe<Array<TeamMembership>>;
  updatedAt: Scalars["DateTime"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
  workspaceMembershipList?: Maybe<Array<WorkspaceMembership>>;
};

export type UserFavorite = {
  __typename?: "UserFavorite";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  pageName: Scalars["String"]["output"];
  pageUrl: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  userId: Scalars["String"]["output"];
  workspaceId: Scalars["String"]["output"];
};

export type UserFavoriteCreateInput = {
  pageName: Scalars["String"]["input"];
  pageUrl: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type UserFavoriteDeleteInput = {
  id: Scalars["String"]["input"];
};

export type UserFavoriteGetInput = {
  workspaceId: Scalars["String"]["input"];
};

export type UserFavoriteRenameInput = {
  id: Scalars["String"]["input"];
  pageName: Scalars["String"]["input"];
};

export type UserGetInput = {
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type UserUpdateInput = {
  activated?: InputMaybe<Scalars["Boolean"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  fullname?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  password?: InputMaybe<Scalars["String"]["input"]>;
  profilePicture?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type Workspace = {
  __typename?: "Workspace";
  activeViewList: Array<ActiveView>;
  createdAt: Scalars["DateTime"]["output"];
  focusAreaList: Array<FocusArea>;
  id: Scalars["String"]["output"];
  labelGroupList: Array<LabelGroup>;
  labelList: Array<Label>;
  logo?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  phaseList: Array<Phase>;
  priorityList: Array<Priority>;
  unitList: Array<Unit>;
  updatedAt: Scalars["DateTime"]["output"];
  workspaceMembershipList: Array<WorkspaceMembership>;
  workspaceUrl: Scalars["String"]["output"];
};

export type WorkspaceCreateInput = {
  logo?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  template: Scalars["String"]["input"];
  userEmailList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  workspaceUrl: Scalars["String"]["input"];
};

export type WorkspaceDeleteCodeCreateInput = {
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceDeleteInput = {
  token: Scalars["String"]["input"];
};

export type WorkspaceDuplicateInput = {
  climateAction_includeAssigneeAssignment: Scalars["Boolean"]["input"];
  climateAction_includeFocusAreaAssignment: Scalars["Boolean"]["input"];
  climateAction_includeLabelAssignment: Scalars["Boolean"]["input"];
  climateAction_includePhaseAssignment: Scalars["Boolean"]["input"];
  climateAction_includePriorityAssignment: Scalars["Boolean"]["input"];
  climateAction_includeTeamAssignment: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  team_includeMembers: Scalars["Boolean"]["input"];
  workspaceId: Scalars["String"]["input"];
  workspace_duplicateClimateActionList: Scalars["Boolean"]["input"];
  workspace_duplicateFocusAreaList: Scalars["Boolean"]["input"];
  workspace_duplicateLabelGroupList: Scalars["Boolean"]["input"];
  workspace_duplicateLabelList: Scalars["Boolean"]["input"];
  workspace_duplicateMembers: Scalars["Boolean"]["input"];
  workspace_duplicatePhaseList: Scalars["Boolean"]["input"];
  workspace_duplicatePriorityList: Scalars["Boolean"]["input"];
  workspace_duplicateTeams: Scalars["Boolean"]["input"];
};

export type WorkspaceInvite = {
  __typename?: "WorkspaceInvite";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  role: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user?: Maybe<User>;
  userId: Scalars["String"]["output"];
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars["String"]["output"];
};

export type WorkspaceInviteAcceptInput = {
  fullname?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type WorkspaceInviteCreateWithEmailInput = {
  email: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceInviteDeleteInput = {
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceInviteUpdateInput = {
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceMembership = {
  __typename?: "WorkspaceMembership";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  role: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user?: Maybe<User>;
  userId: Scalars["String"]["output"];
  workspace?: Maybe<Workspace>;
  workspaceId: Scalars["String"]["output"];
};

export type WorkspaceMembershipCreateInput = {
  role: Scalars["String"]["input"];
  status?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceMembershipDeleteInput = {
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceMembershipGetInput = {
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceMembershipLeaveInput = {
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceMembershipRejoinInput = {
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceMembershipUpdateRoleInput = {
  role: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceMembershipUpdateStatusInput = {
  status: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
  workspaceId: Scalars["String"]["input"];
};

export type WorkspaceUpdateInput = {
  id: Scalars["String"]["input"];
  logo?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  workspaceUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;

export type LoginMutation = { __typename?: "Mutation"; login: { __typename?: "AuthEntity"; token: string } };

export type RefreshMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshMutation = { __typename?: "Mutation"; refresh: { __typename?: "AuthEntity"; token: string } };

export type RequestPasswordResetLinkMutationVariables = Exact<{
  input: PasswordResetLinkRequestInput;
}>;

export type RequestPasswordResetLinkMutation = {
  __typename?: "Mutation";
  requestPasswordResetLink: { __typename?: "EmailEntity"; success: boolean; email: string; message: string };
};

export type CheckPasswordResetTokenMutationVariables = Exact<{
  input: PasswordResetTokenCheckInput;
}>;

export type CheckPasswordResetTokenMutation = {
  __typename?: "Mutation";
  checkPasswordResetToken: { __typename?: "EmailEntity"; success: boolean; email: string; message: string };
};

export type UpdatePasswordWithTokenMutationVariables = Exact<{
  input: PasswordUpdateWithTokenInput;
}>;

export type UpdatePasswordWithTokenMutation = {
  __typename?: "Mutation";
  updatePasswordWithToken: { __typename?: "EmailEntity"; success: boolean; email: string; message: string };
};

export type GetFeatureFlagQueryVariables = Exact<{
  getFeatureFlagInput: GetFeatureFlagInput;
}>;

export type GetFeatureFlagQuery = {
  __typename?: "Query";
  featureFlag?: {
    __typename?: "FeatureFlag";
    id: string;
    userId: string;
    workspaceId: string;
    enabled: boolean;
    payload?: string | null;
  } | null;
};

export type GetFeatureFlagListQueryVariables = Exact<{
  getFeatureFlagListInput: GetFeatureFlagListInput;
}>;

export type GetFeatureFlagListQuery = {
  __typename?: "Query";
  featureFlagList: Array<{
    __typename?: "FeatureFlag";
    id: string;
    userId: string;
    workspaceId: string;
    enabled: boolean;
    payload?: string | null;
  }>;
};

export type FileQueryVariables = Exact<{
  input: FileGetInput;
}>;

export type FileQuery = {
  __typename?: "Query";
  file: {
    __typename?: "MyFile";
    id: string;
    ownerId: string;
    ownerType: string;
    name: string;
    size: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type FileListForOwnerQueryVariables = Exact<{
  input: FileListGetByOwnerInput;
}>;

export type FileListForOwnerQuery = {
  __typename?: "Query";
  fileListForOwner: Array<{
    __typename?: "MyFile";
    id: string;
    ownerId: string;
    ownerType: string;
    name: string;
    size: number;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type CreateFileMutationVariables = Exact<{
  input: FileCreateInput;
}>;

export type CreateFileMutation = {
  __typename?: "Mutation";
  createFile: {
    __typename?: "MyFile";
    id: string;
    ownerId: string;
    ownerType: string;
    name: string;
    size: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type UpdateFileMutationVariables = Exact<{
  input: FileUpdateInput;
}>;

export type UpdateFileMutation = {
  __typename?: "Mutation";
  updateFile: {
    __typename?: "MyFile";
    id: string;
    ownerId: string;
    ownerType: string;
    name: string;
    size: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type ReplaceFileMutationVariables = Exact<{
  input: FileReplaceInput;
}>;

export type ReplaceFileMutation = {
  __typename?: "Mutation";
  replaceFile: {
    __typename?: "MyFile";
    id: string;
    ownerId: string;
    ownerType: string;
    name: string;
    size: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type DeleteFileMutationVariables = Exact<{
  input: FileDeleteInput;
}>;

export type DeleteFileMutation = {
  __typename?: "Mutation";
  deleteFile: {
    __typename?: "MyFile";
    id: string;
    ownerId: string;
    ownerType: string;
    name: string;
    size: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type CreateDownloadLinkMutationVariables = Exact<{
  input: DownloadLinkCreateInput;
}>;

export type CreateDownloadLinkMutation = {
  __typename?: "Mutation";
  createDownloadLink: { __typename?: "DownloadLink"; id: string };
};

export type CreateSignedUploadUrlMutationMutationVariables = Exact<{
  input: SignedUploadUrlCreateInput;
}>;

export type CreateSignedUploadUrlMutationMutation = {
  __typename?: "Mutation";
  createSignedUploadUrl: { __typename?: "SignedUploadUrl"; permaUrl: string; signedUrl: string; type: string };
};

export type MakeFileAccessibleToPublicMutationVariables = Exact<{
  input: MakeFileAccessibleToPublicInput;
}>;

export type MakeFileAccessibleToPublicMutation = { __typename?: "Mutation"; makeFileAccessibleToPublic: string };

export type CheckPermissionQueryVariables = Exact<{
  input: CheckPermissionInput;
}>;

export type CheckPermissionQuery = {
  __typename?: "Query";
  checkPermission: { __typename?: "PermissionResult"; id: string; hasPermission: boolean };
};

export type CheckPermissionListQueryVariables = Exact<{
  input: CheckPermissionsInput;
}>;

export type CheckPermissionListQuery = {
  __typename?: "Query";
  checkPermissionList: Array<{ __typename?: "PermissionResult"; id: string; hasPermission: boolean }>;
};

export type GetSavedViewsByUrlQueryVariables = Exact<{
  input: GetSavedViewsByUrlInput;
}>;

export type GetSavedViewsByUrlQuery = {
  __typename?: "Query";
  savedViews: Array<{
    __typename?: "SavedView";
    id: string;
    userId: string;
    workspaceId: string;
    url: string;
    name: string;
    tableConfiguration: string;
    isBaseView: boolean;
    isDefault: boolean;
  }>;
};

export type GetSavedViewListForWorkspaceQueryVariables = Exact<{
  input: GetSavedViewsForWorkspaceInput;
}>;

export type GetSavedViewListForWorkspaceQuery = {
  __typename?: "Query";
  savedViewListForWorkspace: Array<{
    __typename?: "SavedView";
    id: string;
    userId: string;
    workspaceId: string;
    url: string;
    name: string;
    tableConfiguration: string;
    isBaseView: boolean;
    isDefault: boolean;
  }>;
};

export type CreateSavedViewMutationVariables = Exact<{
  input: CreateSavedViewInput;
}>;

export type CreateSavedViewMutation = {
  __typename?: "Mutation";
  createSavedView: {
    __typename?: "SavedView";
    id: string;
    userId: string;
    workspaceId: string;
    url: string;
    name: string;
    tableConfiguration: string;
    isBaseView: boolean;
    isDefault: boolean;
  };
};

export type UpdateSavedViewMutationVariables = Exact<{
  input: UpdateSavedViewInput;
}>;

export type UpdateSavedViewMutation = {
  __typename?: "Mutation";
  updateSavedView: {
    __typename?: "SavedView";
    id: string;
    userId: string;
    workspaceId: string;
    url: string;
    name: string;
    tableConfiguration: string;
    isBaseView: boolean;
    isDefault: boolean;
  };
};

export type DeleteSavedViewMutationVariables = Exact<{
  input: DeleteSavedViewInput;
}>;

export type DeleteSavedViewMutation = {
  __typename?: "Mutation";
  deleteSavedView: {
    __typename?: "SavedView";
    id: string;
    userId: string;
    workspaceId: string;
    url: string;
    name: string;
    tableConfiguration: string;
    isBaseView: boolean;
    isDefault: boolean;
  };
};

export type GetClimateActionListForWorkspaceQueryVariables = Exact<{
  input: GetClimateActionListForWorkspaceInput;
}>;

export type GetClimateActionListForWorkspaceQuery = {
  __typename?: "Query";
  climateActionListForWorkspace: Array<{
    __typename?: "ClimateAction";
    id: string;
    title: string;
    properties?: string | null;
    parentId?: string | null;
    workspaceId: string;
    parent?: {
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    } | null;
    children: Array<{
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    }>;
    keyResult?: {
      __typename?: "KeyResult";
      id: string;
      climateActionId: string;
      unitId?: string | null;
      title: string;
      description: string;
      initialValue: number;
      targetValue: number;
      currentValue: number;
      startDate: any;
      targetDate: any;
      type: string;
      properties?: string | null;
      unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
    } | null;
    progressSnapshotList: Array<{
      __typename?: "ProgressSnapshot";
      id: string;
      climateActionId: string;
      keyResultId?: string | null;
      userId: string;
      value?: number | null;
      status: string;
      description: string;
      snapshotDate: any;
      properties?: string | null;
    }>;
    assignee?: {
      __typename?: "Assignee";
      id: string;
      userId: string;
      workspaceId: string;
      ownerId: string;
      ownerType: string;
      user: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      };
    } | null;
    priorityInstance?: {
      __typename?: "PriorityInstance";
      id: string;
      priorityId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      priority: { __typename?: "Priority"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    phaseInstance?: {
      __typename?: "PhaseInstance";
      id: string;
      phaseId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    labelInstanceList: Array<{
      __typename?: "LabelInstance";
      id: string;
      labelId: string;
      labelGroupId?: string | null;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      label: {
        __typename?: "Label";
        id: string;
        title: string;
        color: string;
        workspaceId: string;
        labelGroupId?: string | null;
      };
    }>;
    focusAreaInstance?: {
      __typename?: "FocusAreaInstance";
      id: string;
      focusAreaId: string;
      ownerId: string;
      ownerType: string;
      focusArea: {
        __typename?: "FocusArea";
        id: string;
        type: string;
        name: string;
        color: string;
        workspaceId: string;
      };
    } | null;
    teamInstanceList: Array<{
      __typename?: "TeamInstance";
      id: string;
      teamId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
    }>;
  }>;
};

export type GetClimateActionQueryVariables = Exact<{
  input: GetClimateActionInput;
}>;

export type GetClimateActionQuery = {
  __typename?: "Query";
  climateAction: {
    __typename?: "ClimateAction";
    id: string;
    title: string;
    properties?: string | null;
    parentId?: string | null;
    workspaceId: string;
    parent?: {
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    } | null;
    children: Array<{
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    }>;
    keyResult?: {
      __typename?: "KeyResult";
      id: string;
      climateActionId: string;
      unitId?: string | null;
      title: string;
      description: string;
      initialValue: number;
      targetValue: number;
      currentValue: number;
      startDate: any;
      targetDate: any;
      type: string;
      properties?: string | null;
      unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
    } | null;
    progressSnapshotList: Array<{
      __typename?: "ProgressSnapshot";
      id: string;
      climateActionId: string;
      keyResultId?: string | null;
      userId: string;
      value?: number | null;
      status: string;
      description: string;
      snapshotDate: any;
      properties?: string | null;
    }>;
    assignee?: {
      __typename?: "Assignee";
      id: string;
      userId: string;
      workspaceId: string;
      ownerId: string;
      ownerType: string;
      user: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      };
    } | null;
    priorityInstance?: {
      __typename?: "PriorityInstance";
      id: string;
      priorityId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      priority: { __typename?: "Priority"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    phaseInstance?: {
      __typename?: "PhaseInstance";
      id: string;
      phaseId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    labelInstanceList: Array<{
      __typename?: "LabelInstance";
      id: string;
      labelId: string;
      labelGroupId?: string | null;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      label: {
        __typename?: "Label";
        id: string;
        title: string;
        color: string;
        workspaceId: string;
        labelGroupId?: string | null;
      };
    }>;
    focusAreaInstance?: {
      __typename?: "FocusAreaInstance";
      id: string;
      focusAreaId: string;
      ownerId: string;
      ownerType: string;
      focusArea: {
        __typename?: "FocusArea";
        id: string;
        type: string;
        name: string;
        color: string;
        workspaceId: string;
      };
    } | null;
    teamInstanceList: Array<{
      __typename?: "TeamInstance";
      id: string;
      teamId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
    }>;
  };
};

export type CreateClimateActionMutationVariables = Exact<{
  input: CreateClimateActionInput;
}>;

export type CreateClimateActionMutation = {
  __typename?: "Mutation";
  createClimateAction: {
    __typename?: "ClimateAction";
    id: string;
    title: string;
    properties?: string | null;
    parentId?: string | null;
    workspaceId: string;
    parent?: {
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    } | null;
    children: Array<{
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    }>;
    keyResult?: {
      __typename?: "KeyResult";
      id: string;
      climateActionId: string;
      unitId?: string | null;
      title: string;
      description: string;
      initialValue: number;
      targetValue: number;
      currentValue: number;
      startDate: any;
      targetDate: any;
      type: string;
      properties?: string | null;
      unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
    } | null;
    progressSnapshotList: Array<{
      __typename?: "ProgressSnapshot";
      id: string;
      climateActionId: string;
      keyResultId?: string | null;
      userId: string;
      value?: number | null;
      status: string;
      description: string;
      snapshotDate: any;
      properties?: string | null;
    }>;
    assignee?: {
      __typename?: "Assignee";
      id: string;
      userId: string;
      workspaceId: string;
      ownerId: string;
      ownerType: string;
      user: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      };
    } | null;
    priorityInstance?: {
      __typename?: "PriorityInstance";
      id: string;
      priorityId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      priority: { __typename?: "Priority"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    phaseInstance?: {
      __typename?: "PhaseInstance";
      id: string;
      phaseId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    labelInstanceList: Array<{
      __typename?: "LabelInstance";
      id: string;
      labelId: string;
      labelGroupId?: string | null;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      label: {
        __typename?: "Label";
        id: string;
        title: string;
        color: string;
        workspaceId: string;
        labelGroupId?: string | null;
      };
    }>;
    focusAreaInstance?: {
      __typename?: "FocusAreaInstance";
      id: string;
      focusAreaId: string;
      ownerId: string;
      ownerType: string;
      focusArea: {
        __typename?: "FocusArea";
        id: string;
        type: string;
        name: string;
        color: string;
        workspaceId: string;
      };
    } | null;
    teamInstanceList: Array<{
      __typename?: "TeamInstance";
      id: string;
      teamId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
    }>;
  };
};

export type UpdateClimateActionMutationVariables = Exact<{
  input: UpdateClimateActionInput;
}>;

export type UpdateClimateActionMutation = {
  __typename?: "Mutation";
  updateClimateAction: {
    __typename?: "ClimateAction";
    id: string;
    title: string;
    properties?: string | null;
    parentId?: string | null;
    workspaceId: string;
    parent?: {
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    } | null;
    children: Array<{
      __typename?: "ClimateAction";
      id: string;
      title: string;
      properties?: string | null;
      parentId?: string | null;
    }>;
    keyResult?: {
      __typename?: "KeyResult";
      id: string;
      climateActionId: string;
      unitId?: string | null;
      title: string;
      description: string;
      initialValue: number;
      targetValue: number;
      currentValue: number;
      startDate: any;
      targetDate: any;
      type: string;
      properties?: string | null;
      unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
    } | null;
    progressSnapshotList: Array<{
      __typename?: "ProgressSnapshot";
      id: string;
      climateActionId: string;
      keyResultId?: string | null;
      userId: string;
      value?: number | null;
      status: string;
      description: string;
      snapshotDate: any;
      properties?: string | null;
    }>;
    assignee?: {
      __typename?: "Assignee";
      id: string;
      userId: string;
      workspaceId: string;
      ownerId: string;
      ownerType: string;
      user: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      };
    } | null;
    priorityInstance?: {
      __typename?: "PriorityInstance";
      id: string;
      priorityId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      priority: { __typename?: "Priority"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    phaseInstance?: {
      __typename?: "PhaseInstance";
      id: string;
      phaseId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
    } | null;
    labelInstanceList: Array<{
      __typename?: "LabelInstance";
      id: string;
      labelId: string;
      labelGroupId?: string | null;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
      label: {
        __typename?: "Label";
        id: string;
        title: string;
        color: string;
        workspaceId: string;
        labelGroupId?: string | null;
      };
    }>;
    focusAreaInstance?: {
      __typename?: "FocusAreaInstance";
      id: string;
      focusAreaId: string;
      ownerId: string;
      ownerType: string;
      focusArea: {
        __typename?: "FocusArea";
        id: string;
        type: string;
        name: string;
        color: string;
        workspaceId: string;
      };
    } | null;
    teamInstanceList: Array<{
      __typename?: "TeamInstance";
      id: string;
      teamId: string;
      ownerId: string;
      ownerType: string;
      workspaceId: string;
    }>;
  };
};

export type DeleteClimateActionMutationVariables = Exact<{
  input: DeleteClimateActionInput;
}>;

export type DeleteClimateActionMutation = {
  __typename?: "Mutation";
  deleteClimateAction: {
    __typename?: "ClimateAction";
    id: string;
    title: string;
    properties?: string | null;
    parentId?: string | null;
    workspaceId: string;
  };
};

export type GetFocusAreaInstanceQueryVariables = Exact<{
  input: GetFocusAreaInstanceInput;
}>;

export type GetFocusAreaInstanceQuery = {
  __typename?: "Query";
  focusAreaInstance: {
    __typename?: "FocusAreaInstance";
    id: string;
    focusAreaId: string;
    ownerId: string;
    ownerType: string;
    focusArea: { __typename?: "FocusArea"; id: string; type: string; name: string; color: string; workspaceId: string };
  };
};

export type GetFocusAreaInstanceByOwnerQueryVariables = Exact<{
  input: GetFocusAreaInstanceByOwnerInput;
}>;

export type GetFocusAreaInstanceByOwnerQuery = {
  __typename?: "Query";
  focusAreaInstanceByOwner?: {
    __typename?: "FocusAreaInstance";
    id: string;
    focusAreaId: string;
    ownerId: string;
    ownerType: string;
    focusArea: { __typename?: "FocusArea"; id: string; type: string; name: string; color: string; workspaceId: string };
  } | null;
};

export type CreateFocusAreaInstanceMutationVariables = Exact<{
  input: CreateFocusAreaInstanceInput;
}>;

export type CreateFocusAreaInstanceMutation = {
  __typename?: "Mutation";
  createFocusAreaInstance: {
    __typename?: "FocusAreaInstance";
    id: string;
    workspaceId: string;
    focusAreaId: string;
    ownerId: string;
    ownerType: string;
    focusArea: { __typename?: "FocusArea"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type UpdateFocusAreaInstanceMutationVariables = Exact<{
  input: UpdateFocusAreaInstanceInput;
}>;

export type UpdateFocusAreaInstanceMutation = {
  __typename?: "Mutation";
  updateFocusAreaInstance: {
    __typename?: "FocusAreaInstance";
    id: string;
    workspaceId: string;
    focusAreaId: string;
    ownerId: string;
    ownerType: string;
    focusArea: { __typename?: "FocusArea"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type DeleteFocusAreaInstanceMutationVariables = Exact<{
  input: DeleteFocusAreaInstanceInput;
}>;

export type DeleteFocusAreaInstanceMutation = {
  __typename?: "Mutation";
  deleteFocusAreaInstance: {
    __typename?: "FocusAreaInstance";
    id: string;
    workspaceId: string;
    focusAreaId: string;
    ownerId: string;
    ownerType: string;
    focusArea: { __typename?: "FocusArea"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type GetFocusAreaQueryVariables = Exact<{
  input: GetFocusAreaInput;
}>;

export type GetFocusAreaQuery = {
  __typename?: "Query";
  focusArea: {
    __typename?: "FocusArea";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
  };
};

export type GetFocusAreaListForWorkspaceQueryVariables = Exact<{
  input: GetFocusAreaListForWorkspaceInput;
}>;

export type GetFocusAreaListForWorkspaceQuery = {
  __typename?: "Query";
  focusAreaListForWorkspace: Array<{
    __typename?: "FocusArea";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
  }>;
};

export type CreateFocusAreaMutationVariables = Exact<{
  input: CreateFocusAreaInput;
}>;

export type CreateFocusAreaMutation = {
  __typename?: "Mutation";
  createFocusArea: {
    __typename?: "FocusArea";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
  };
};

export type UpdateFocusAreaMutationVariables = Exact<{
  input: UpdateFocusAreaInput;
}>;

export type UpdateFocusAreaMutation = {
  __typename?: "Mutation";
  updateFocusArea: {
    __typename?: "FocusArea";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
  };
};

export type DeleteFocusAreaMutationVariables = Exact<{
  input: DeleteFocusAreaInput;
}>;

export type DeleteFocusAreaMutation = {
  __typename?: "Mutation";
  deleteFocusArea: {
    __typename?: "FocusArea";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
  };
};

export type GetIndicatorQueryVariables = Exact<{
  input: GetIndicatorInput;
}>;

export type GetIndicatorQuery = {
  __typename?: "Query";
  indicator: {
    __typename?: "Indicator";
    id: string;
    workspaceId: string;
    title: string;
    description?: string | null;
    type: string;
    unitId?: string | null;
    createdAt: any;
    updatedAt: any;
    valueCount: number;
    unit?: { __typename?: "Unit"; id: string; workspaceId: string; title: string; symbol: string } | null;
    values: Array<{
      __typename?: "IndicatorValue";
      id: string;
      indicatorId: string;
      value: number;
      date: any;
      comment?: string | null;
      createdAt: any;
      updatedAt: any;
    }>;
    latestValue?: {
      __typename?: "IndicatorValue";
      id: string;
      indicatorId: string;
      value: number;
      date: any;
      comment?: string | null;
      createdAt: any;
      updatedAt: any;
    } | null;
  };
};

export type GetIndicatorListQueryVariables = Exact<{
  input: GetIndicatorListInput;
}>;

export type GetIndicatorListQuery = {
  __typename?: "Query";
  indicatorList: Array<{
    __typename?: "Indicator";
    id: string;
    workspaceId: string;
    title: string;
    description?: string | null;
    type: string;
    unitId?: string | null;
    createdAt: any;
    updatedAt: any;
    valueCount: number;
    unit?: { __typename?: "Unit"; id: string; workspaceId: string; title: string; symbol: string } | null;
    latestValue?: {
      __typename?: "IndicatorValue";
      id: string;
      indicatorId: string;
      value: number;
      date: any;
      comment?: string | null;
      createdAt: any;
      updatedAt: any;
    } | null;
  }>;
};

export type CreateIndicatorMutationVariables = Exact<{
  input: CreateIndicatorInput;
}>;

export type CreateIndicatorMutation = {
  __typename?: "Mutation";
  createIndicator: {
    __typename?: "Indicator";
    id: string;
    workspaceId: string;
    title: string;
    description?: string | null;
    type: string;
    unitId?: string | null;
    createdAt: any;
    updatedAt: any;
    valueCount: number;
    unit?: { __typename?: "Unit"; id: string; workspaceId: string; title: string; symbol: string } | null;
    values: Array<{
      __typename?: "IndicatorValue";
      id: string;
      indicatorId: string;
      value: number;
      date: any;
      comment?: string | null;
      createdAt: any;
      updatedAt: any;
    }>;
    latestValue?: {
      __typename?: "IndicatorValue";
      id: string;
      indicatorId: string;
      value: number;
      date: any;
      comment?: string | null;
      createdAt: any;
      updatedAt: any;
    } | null;
  };
};

export type UpdateIndicatorMutationVariables = Exact<{
  input: UpdateIndicatorInput;
}>;

export type UpdateIndicatorMutation = {
  __typename?: "Mutation";
  updateIndicator: {
    __typename?: "Indicator";
    id: string;
    workspaceId: string;
    title: string;
    description?: string | null;
    type: string;
    unitId?: string | null;
    createdAt: any;
    updatedAt: any;
    valueCount: number;
    unit?: { __typename?: "Unit"; id: string; workspaceId: string; title: string; symbol: string } | null;
    values: Array<{
      __typename?: "IndicatorValue";
      id: string;
      indicatorId: string;
      value: number;
      date: any;
      comment?: string | null;
      createdAt: any;
      updatedAt: any;
    }>;
    latestValue?: {
      __typename?: "IndicatorValue";
      id: string;
      indicatorId: string;
      value: number;
      date: any;
      comment?: string | null;
      createdAt: any;
      updatedAt: any;
    } | null;
  };
};

export type DeleteIndicatorMutationVariables = Exact<{
  input: DeleteIndicatorInput;
}>;

export type DeleteIndicatorMutation = {
  __typename?: "Mutation";
  deleteIndicator: {
    __typename?: "Indicator";
    id: string;
    workspaceId: string;
    title: string;
    description?: string | null;
    type: string;
    unitId?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type CreateIndicatorValueMutationVariables = Exact<{
  input: CreateIndicatorValueInput;
}>;

export type CreateIndicatorValueMutation = {
  __typename?: "Mutation";
  createIndicatorValue: {
    __typename?: "IndicatorValue";
    id: string;
    indicatorId: string;
    value: number;
    date: any;
    comment?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type UpdateIndicatorValueMutationVariables = Exact<{
  input: UpdateIndicatorValueInput;
}>;

export type UpdateIndicatorValueMutation = {
  __typename?: "Mutation";
  updateIndicatorValue: {
    __typename?: "IndicatorValue";
    id: string;
    indicatorId: string;
    value: number;
    date: any;
    comment?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type DeleteIndicatorValueMutationVariables = Exact<{
  input: DeleteIndicatorValueInput;
}>;

export type DeleteIndicatorValueMutation = {
  __typename?: "Mutation";
  deleteIndicatorValue: {
    __typename?: "IndicatorValue";
    id: string;
    indicatorId: string;
    value: number;
    date: any;
    comment?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type GetKeyResultQueryVariables = Exact<{
  input: GetKeyResultInput;
}>;

export type GetKeyResultQuery = {
  __typename?: "Query";
  keyResult: {
    __typename?: "KeyResult";
    id: string;
    climateActionId: string;
    unitId?: string | null;
    title: string;
    description: string;
    initialValue: number;
    targetValue: number;
    currentValue: number;
    startDate: any;
    targetDate: any;
    type: string;
    properties?: string | null;
    unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
  };
};

export type CreateKeyResultMutationVariables = Exact<{
  input: CreateKeyResultInput;
}>;

export type CreateKeyResultMutation = {
  __typename?: "Mutation";
  createKeyResult: {
    __typename?: "KeyResult";
    id: string;
    climateActionId: string;
    unitId?: string | null;
    title: string;
    description: string;
    initialValue: number;
    targetValue: number;
    currentValue: number;
    startDate: any;
    targetDate: any;
    type: string;
    properties?: string | null;
    unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
  };
};

export type UpdateKeyResultMutationVariables = Exact<{
  input: UpdateKeyResultInput;
}>;

export type UpdateKeyResultMutation = {
  __typename?: "Mutation";
  updateKeyResult: {
    __typename?: "KeyResult";
    id: string;
    climateActionId: string;
    unitId?: string | null;
    title: string;
    description: string;
    initialValue: number;
    targetValue: number;
    currentValue: number;
    startDate: any;
    targetDate: any;
    type: string;
    properties?: string | null;
    unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
  };
};

export type DeleteKeyResultMutationVariables = Exact<{
  input: DeleteKeyResultInput;
}>;

export type DeleteKeyResultMutation = {
  __typename?: "Mutation";
  deleteKeyResult: {
    __typename?: "KeyResult";
    id: string;
    climateActionId: string;
    unitId?: string | null;
    title: string;
    description: string;
    initialValue: number;
    targetValue: number;
    currentValue: number;
    startDate: any;
    targetDate: any;
    type: string;
    properties?: string | null;
    unit?: { __typename?: "Unit"; id: string; title: string; symbol: string } | null;
  };
};

export type GetLabelGroupListForWorkspaceQueryVariables = Exact<{
  input: GetLabelGroupListForWorkspaceInput;
}>;

export type GetLabelGroupListForWorkspaceQuery = {
  __typename?: "Query";
  labelGroupListForWorkspace: Array<{
    __typename?: "LabelGroup";
    id: string;
    title: string;
    color: string;
    allowMultiSelect: boolean;
    workspaceId: string;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      labelGroupId?: string | null;
      workspaceId: string;
    }>;
  }>;
};

export type GetLabelGroupQueryVariables = Exact<{
  input: GetLabelGroupInput;
}>;

export type GetLabelGroupQuery = {
  __typename?: "Query";
  labelGroup: {
    __typename?: "LabelGroup";
    id: string;
    title: string;
    color: string;
    allowMultiSelect: boolean;
    workspaceId: string;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      labelGroupId?: string | null;
      workspaceId: string;
    }>;
  };
};

export type CreateLabelGroupMutationVariables = Exact<{
  input: CreateLabelGroupInput;
}>;

export type CreateLabelGroupMutation = {
  __typename?: "Mutation";
  createLabelGroup: {
    __typename?: "LabelGroup";
    id: string;
    title: string;
    color: string;
    allowMultiSelect: boolean;
    workspaceId: string;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      labelGroupId?: string | null;
      workspaceId: string;
    }>;
  };
};

export type UpdateLabelGroupMutationVariables = Exact<{
  input: UpdateLabelGroupInput;
}>;

export type UpdateLabelGroupMutation = {
  __typename?: "Mutation";
  updateLabelGroup: {
    __typename?: "LabelGroup";
    id: string;
    title: string;
    color: string;
    allowMultiSelect: boolean;
    workspaceId: string;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      labelGroupId?: string | null;
      workspaceId: string;
    }>;
  };
};

export type DeleteLabelGroupMutationVariables = Exact<{
  input: DeleteLabelGroupInput;
}>;

export type DeleteLabelGroupMutation = {
  __typename?: "Mutation";
  deleteLabelGroup: {
    __typename?: "LabelGroup";
    id: string;
    title: string;
    color: string;
    allowMultiSelect: boolean;
    workspaceId: string;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      labelGroupId?: string | null;
      workspaceId: string;
    }>;
  };
};

export type GetLabelInstanceListQueryVariables = Exact<{
  input: GetLabelInstanceListInput;
}>;

export type GetLabelInstanceListQuery = {
  __typename?: "Query";
  labelInstanceList: Array<{
    __typename?: "LabelInstance";
    id: string;
    labelId: string;
    labelGroupId?: string | null;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
    label: {
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      workspaceId: string;
      labelGroupId?: string | null;
    };
  }>;
};

export type GetLabelInstanceQueryVariables = Exact<{
  input: GetLabelInstanceInput;
}>;

export type GetLabelInstanceQuery = {
  __typename?: "Query";
  labelInstance: {
    __typename?: "LabelInstance";
    id: string;
    labelId: string;
    labelGroupId?: string | null;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
    label: {
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      workspaceId: string;
      labelGroupId?: string | null;
    };
  };
};

export type CreateLabelInstanceMutationVariables = Exact<{
  input: CreateLabelInstanceInput;
}>;

export type CreateLabelInstanceMutation = {
  __typename?: "Mutation";
  createLabelInstance: {
    __typename?: "LabelInstance";
    id: string;
    labelId: string;
    labelGroupId?: string | null;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
    label: {
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      workspaceId: string;
      labelGroupId?: string | null;
    };
  };
};

export type DeleteLabelInstanceMutationVariables = Exact<{
  input: DeleteLabelInstanceInput;
}>;

export type DeleteLabelInstanceMutation = {
  __typename?: "Mutation";
  deleteLabelInstance: {
    __typename?: "LabelInstance";
    id: string;
    labelId: string;
    labelGroupId?: string | null;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
    label: {
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      workspaceId: string;
      labelGroupId?: string | null;
    };
  };
};

export type GetLabelListForWorkspaceQueryVariables = Exact<{
  input: GetLabelListForWorkspaceInput;
}>;

export type GetLabelListForWorkspaceQuery = {
  __typename?: "Query";
  labelListForWorkspace: Array<{
    __typename?: "Label";
    id: string;
    title: string;
    color: string;
    workspaceId: string;
    labelGroupId?: string | null;
    instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
  }>;
};

export type GetLabelQueryVariables = Exact<{
  input: GetLabelInput;
}>;

export type GetLabelQuery = {
  __typename?: "Query";
  label: {
    __typename?: "Label";
    id: string;
    title: string;
    color: string;
    labelGroupId?: string | null;
    workspaceId: string;
    instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
  };
};

export type CreateLabelMutationVariables = Exact<{
  input: CreateLabelInput;
}>;

export type CreateLabelMutation = {
  __typename?: "Mutation";
  createLabel: {
    __typename?: "Label";
    id: string;
    title: string;
    color: string;
    labelGroupId?: string | null;
    workspaceId: string;
    instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
  };
};

export type UpdateLabelMutationVariables = Exact<{
  input: UpdateLabelInput;
}>;

export type UpdateLabelMutation = {
  __typename?: "Mutation";
  updateLabel: {
    __typename?: "Label";
    id: string;
    title: string;
    color: string;
    labelGroupId?: string | null;
    workspaceId: string;
    instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
  };
};

export type DeleteLabelMutationVariables = Exact<{
  input: DeleteLabelInput;
}>;

export type DeleteLabelMutation = {
  __typename?: "Mutation";
  deleteLabel: {
    __typename?: "Label";
    id: string;
    title: string;
    color: string;
    labelGroupId?: string | null;
    workspaceId: string;
    instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
  };
};

export type GetPhaseInstanceQueryVariables = Exact<{
  input: GetPhaseInstanceInput;
}>;

export type GetPhaseInstanceQuery = {
  __typename?: "Query";
  phaseInstance: {
    __typename?: "PhaseInstance";
    id: string;
    phaseId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
    phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type GetPhaseInstanceByOwnerQueryVariables = Exact<{
  input: GetPhaseInstanceByOwnerInput;
}>;

export type GetPhaseInstanceByOwnerQuery = {
  __typename?: "Query";
  phaseInstanceByOwner?: {
    __typename?: "PhaseInstance";
    id: string;
    phaseId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
    phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
  } | null;
};

export type CreatePhaseInstanceMutationVariables = Exact<{
  input: CreatePhaseInstanceInput;
}>;

export type CreatePhaseInstanceMutation = {
  __typename?: "Mutation";
  createPhaseInstance: {
    __typename?: "PhaseInstance";
    id: string;
    workspaceId: string;
    phaseId: string;
    ownerId: string;
    ownerType: string;
    phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type UpdatePhaseInstanceMutationVariables = Exact<{
  input: UpdatePhaseInstanceInput;
}>;

export type UpdatePhaseInstanceMutation = {
  __typename?: "Mutation";
  updatePhaseInstance: {
    __typename?: "PhaseInstance";
    id: string;
    workspaceId: string;
    phaseId: string;
    ownerId: string;
    ownerType: string;
    phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type DeletePhaseInstanceMutationVariables = Exact<{
  input: DeletePhaseInstanceInput;
}>;

export type DeletePhaseInstanceMutation = {
  __typename?: "Mutation";
  deletePhaseInstance: {
    __typename?: "PhaseInstance";
    id: string;
    workspaceId: string;
    phaseId: string;
    ownerId: string;
    ownerType: string;
    phase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type GetPhaseListForWorkspaceQueryVariables = Exact<{
  input: GetPhaseListForWorkspaceInput;
}>;

export type GetPhaseListForWorkspaceQuery = {
  __typename?: "Query";
  phaseListForWorkspace: Array<{
    __typename?: "Phase";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
  }>;
};

export type GetPhaseQueryVariables = Exact<{
  input: GetPhaseInput;
}>;

export type GetPhaseQuery = {
  __typename?: "Query";
  phase: {
    __typename?: "Phase";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
  };
};

export type CreatePhaseMutationVariables = Exact<{
  input: CreatePhaseInput;
}>;

export type CreatePhaseMutation = {
  __typename?: "Mutation";
  createPhase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
};

export type UpdatePhaseMutationVariables = Exact<{
  input: UpdatePhaseInput;
}>;

export type UpdatePhaseMutation = {
  __typename?: "Mutation";
  updatePhase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
};

export type DeletePhaseMutationVariables = Exact<{
  input: DeletePhaseInput;
}>;

export type DeletePhaseMutation = {
  __typename?: "Mutation";
  deletePhase: { __typename?: "Phase"; id: string; workspaceId: string; name: string; color: string; type: string };
};

export type GetPriorityInstanceQueryVariables = Exact<{
  input: GetPriorityInstanceInput;
}>;

export type GetPriorityInstanceQuery = {
  __typename?: "Query";
  priorityInstance: {
    __typename?: "PriorityInstance";
    id: string;
    priorityId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
  };
};

export type GetPriorityInstanceByOwnerQueryVariables = Exact<{
  input: GetPriorityInstanceByOwnerInput;
}>;

export type GetPriorityInstanceByOwnerQuery = {
  __typename?: "Query";
  priorityInstanceByOwner?: {
    __typename?: "PriorityInstance";
    id: string;
    priorityId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
  } | null;
};

export type CreatePriorityInstanceMutationVariables = Exact<{
  input: CreatePriorityInstanceInput;
}>;

export type CreatePriorityInstanceMutation = {
  __typename?: "Mutation";
  createPriorityInstance: {
    __typename?: "PriorityInstance";
    id: string;
    workspaceId: string;
    priorityId: string;
    ownerId: string;
    ownerType: string;
    priority: { __typename?: "Priority"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type UpdatePriorityInstanceMutationVariables = Exact<{
  input: UpdatePriorityInstanceInput;
}>;

export type UpdatePriorityInstanceMutation = {
  __typename?: "Mutation";
  updatePriorityInstance: {
    __typename?: "PriorityInstance";
    id: string;
    workspaceId: string;
    priorityId: string;
    ownerId: string;
    ownerType: string;
    priority: { __typename?: "Priority"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type DeletePriorityInstanceMutationVariables = Exact<{
  input: DeletePriorityInstanceInput;
}>;

export type DeletePriorityInstanceMutation = {
  __typename?: "Mutation";
  deletePriorityInstance: {
    __typename?: "PriorityInstance";
    id: string;
    workspaceId: string;
    priorityId: string;
    ownerId: string;
    ownerType: string;
    priority: { __typename?: "Priority"; id: string; workspaceId: string; name: string; color: string; type: string };
  };
};

export type GetPriorityQueryVariables = Exact<{
  input: GetPriorityInput;
}>;

export type GetPriorityQuery = {
  __typename?: "Query";
  priority: {
    __typename?: "Priority";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
  };
};

export type GetPriorityListForWorkspaceQueryVariables = Exact<{
  input: GetPriorityListForWorkspaceInput;
}>;

export type GetPriorityListForWorkspaceQuery = {
  __typename?: "Query";
  priorityListForWorkspace: Array<{
    __typename?: "Priority";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
  }>;
};

export type CreatePriorityMutationVariables = Exact<{
  input: CreatePriorityInput;
}>;

export type CreatePriorityMutation = {
  __typename?: "Mutation";
  createPriority: {
    __typename?: "Priority";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
  };
};

export type UpdatePriorityMutationVariables = Exact<{
  input: UpdatePriorityInput;
}>;

export type UpdatePriorityMutation = {
  __typename?: "Mutation";
  updatePriority: {
    __typename?: "Priority";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
  };
};

export type DeletePriorityMutationVariables = Exact<{
  input: DeletePriorityInput;
}>;

export type DeletePriorityMutation = {
  __typename?: "Mutation";
  deletePriority: {
    __typename?: "Priority";
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    type: string;
    instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
  };
};

export type GetProgressSnapshotQueryVariables = Exact<{
  input: GetProgressSnapshotInput;
}>;

export type GetProgressSnapshotQuery = {
  __typename?: "Query";
  progressSnapshot: {
    __typename?: "ProgressSnapshot";
    id: string;
    climateActionId: string;
    keyResultId?: string | null;
    userId: string;
    value?: number | null;
    status: string;
    description: string;
    snapshotDate: any;
    properties?: string | null;
  };
};

export type GetProgressSnapshotsQueryVariables = Exact<{
  input: GetProgressSnapshotsInput;
}>;

export type GetProgressSnapshotsQuery = {
  __typename?: "Query";
  progressSnapshots: Array<{
    __typename?: "ProgressSnapshot";
    id: string;
    climateActionId: string;
    keyResultId?: string | null;
    userId: string;
    value?: number | null;
    status: string;
    description: string;
    snapshotDate: any;
    properties?: string | null;
  }>;
};

export type GetProgressSnapshotsForKeyResultsQueryVariables = Exact<{
  input: GetProgressSnapshotsForKeyResultInput;
}>;

export type GetProgressSnapshotsForKeyResultsQuery = {
  __typename?: "Query";
  progressSnapshotsForKeyResult: Array<{
    __typename?: "ProgressSnapshot";
    id: string;
    climateActionId: string;
    keyResultId?: string | null;
    userId: string;
    value?: number | null;
    status: string;
    description: string;
    snapshotDate: any;
    properties?: string | null;
  }>;
};

export type CreateProgressSnapshotMutationVariables = Exact<{
  input: CreateProgressSnapshotInput;
}>;

export type CreateProgressSnapshotMutation = {
  __typename?: "Mutation";
  createProgressSnapshot: {
    __typename?: "ProgressSnapshot";
    id: string;
    keyResultId?: string | null;
    userId: string;
    value?: number | null;
    status: string;
    description: string;
    snapshotDate: any;
    properties?: string | null;
  };
};

export type DeleteProgressSnapshotMutationVariables = Exact<{
  input: DeleteProgressSnapshotInput;
}>;

export type DeleteProgressSnapshotMutation = {
  __typename?: "Mutation";
  deleteProgressSnapshot: {
    __typename?: "ProgressSnapshot";
    id: string;
    keyResultId?: string | null;
    userId: string;
    value?: number | null;
    status: string;
    description: string;
    snapshotDate: any;
    properties?: string | null;
  };
};

export type GetAllTasksQueryVariables = Exact<{
  input: GetAllTaskListInput;
}>;

export type GetAllTasksQuery = {
  __typename?: "Query";
  getAllTasks: Array<{
    __typename?: "Task";
    id: string;
    userId: string;
    title: string;
    description?: string | null;
    status: string;
    position: number;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;

export type UpdateTaskMutation = {
  __typename?: "Mutation";
  updateTask: {
    __typename?: "Task";
    id: string;
    userId: string;
    title: string;
    description?: string | null;
    status: string;
    position: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type UpdateTaskListMutationVariables = Exact<{
  input: UpdateTaskListInput;
}>;

export type UpdateTaskListMutation = {
  __typename?: "Mutation";
  updateTaskList: Array<{
    __typename?: "Task";
    id: string;
    userId: string;
    title: string;
    description?: string | null;
    status: string;
    position: number;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;

export type CreateTaskMutation = {
  __typename?: "Mutation";
  createTask: {
    __typename?: "Task";
    id: string;
    userId: string;
    title: string;
    description?: string | null;
    status: string;
    position: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type DeleteTaskMutationVariables = Exact<{
  input: DeleteTaskByIdInput;
}>;

export type DeleteTaskMutation = {
  __typename?: "Mutation";
  deleteTask: {
    __typename?: "Task";
    id: string;
    userId: string;
    title: string;
    description?: string | null;
    status: string;
    position: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type GetTeamInstanceQueryVariables = Exact<{
  getTeamInstanceInput: GetTeamInstanceInput;
}>;

export type GetTeamInstanceQuery = {
  __typename?: "Query";
  teamInstance: {
    __typename?: "TeamInstance";
    id: string;
    teamId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
  };
};

export type GetTeamInstanceByOwnerQueryVariables = Exact<{
  getTeamInstanceByOwnerInput: GetTeamInstanceByOwnerInput;
}>;

export type GetTeamInstanceByOwnerQuery = {
  __typename?: "Query";
  teamInstanceByOwner?: {
    __typename?: "TeamInstance";
    id: string;
    teamId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
  } | null;
};

export type CreateTeamInstanceMutationVariables = Exact<{
  input: CreateTeamInstanceInput;
}>;

export type CreateTeamInstanceMutation = {
  __typename?: "Mutation";
  createTeamInstance: {
    __typename?: "TeamInstance";
    id: string;
    teamId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
  };
};

export type UpdateTeamInstanceListForOwnerMutationVariables = Exact<{
  input: UpdateTeamInstanceListForOwnerInput;
}>;

export type UpdateTeamInstanceListForOwnerMutation = {
  __typename?: "Mutation";
  updateTeamInstanceListForOwner: Array<{
    __typename?: "TeamInstance";
    id: string;
    teamId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
  }>;
};

export type DeleteTeamInstanceMutationVariables = Exact<{
  input: DeleteTeamInstanceInput;
}>;

export type DeleteTeamInstanceMutation = {
  __typename?: "Mutation";
  deleteTeamInstance: {
    __typename?: "TeamInstance";
    id: string;
    teamId: string;
    ownerId: string;
    ownerType: string;
    workspaceId: string;
  };
};

export type TeamMembershipListQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type TeamMembershipListQuery = {
  __typename?: "Query";
  teamMembershipList: Array<{
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  }>;
};

export type FindTeamInviteQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type FindTeamInviteQuery = {
  __typename?: "Query";
  findTeamInvite: {
    __typename?: "TeamInvite";
    userId: string;
    teamId: string;
    pendingWorkspaceMembership: boolean;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
      activated: boolean;
    } | null;
    team?: {
      __typename?: "Team";
      id: string;
      workspaceId: string;
      name: string;
      visibility: string;
      logo?: string | null;
      color?: string | null;
      workspace: { __typename?: "Workspace"; id: string; name: string; workspaceUrl: string; logo?: string | null };
    } | null;
  };
};

export type UpdateTeamMembershipRoleMutationVariables = Exact<{
  input: TeamMembershipUpdateRoleInput;
}>;

export type UpdateTeamMembershipRoleMutation = {
  __typename?: "Mutation";
  updateTeamMembershipRole: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type UpdateTeamMembershipStatusMutationVariables = Exact<{
  input: TeamMembershipUpdateStatusInput;
}>;

export type UpdateTeamMembershipStatusMutation = {
  __typename?: "Mutation";
  updateTeamMembershipStatus: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type LeaveTeamMutationVariables = Exact<{
  input: TeamMembershipLeaveInput;
}>;

export type LeaveTeamMutation = {
  __typename?: "Mutation";
  leaveTeam: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type RejoinTeamMembershipMutationVariables = Exact<{
  input: TeamMembershipRejoinInput;
}>;

export type RejoinTeamMembershipMutation = {
  __typename?: "Mutation";
  rejoinTeamMembership: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type CreateTeamInviteMutationVariables = Exact<{
  input: TeamInviteCreateInput;
}>;

export type CreateTeamInviteMutation = {
  __typename?: "Mutation";
  createTeamInvite: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type AcceptTeamInviteMutationVariables = Exact<{
  input: TeamInviteAcceptInput;
}>;

export type AcceptTeamInviteMutation = {
  __typename?: "Mutation";
  acceptTeamInvite: {
    __typename?: "TeamInvite";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type DeleteTeamInviteMutationVariables = Exact<{
  input: TeamInviteDeleteInput;
}>;

export type DeleteTeamInviteMutation = {
  __typename?: "Mutation";
  deleteTeamInvite: {
    __typename?: "TeamInvite";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type ResendTeamInviteNotificationMutationVariables = Exact<{
  input: TeamInviteUpdateInput;
}>;

export type ResendTeamInviteNotificationMutation = {
  __typename?: "Mutation";
  resendTeamInviteNotification: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type JoinTeamMutationVariables = Exact<{
  input: TeamMembershipJoinInput;
}>;

export type JoinTeamMutation = {
  __typename?: "Mutation";
  joinTeam: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type TeamByIdQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type TeamByIdQuery = {
  __typename?: "Query";
  teamById: {
    __typename?: "Team";
    id: string;
    workspaceId: string;
    name: string;
    visibility: string;
    logo?: string | null;
    logoType?: string | null;
    color?: string | null;
    teamMembershipList: Array<{
      __typename?: "TeamMembership";
      id: string;
      userId: string;
      teamId: string;
      role: string;
      status: string;
    }>;
  };
};

export type TeamListForWorkspaceQueryQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type TeamListForWorkspaceQueryQuery = {
  __typename?: "Query";
  teamListForWorkspace: Array<{
    __typename?: "Team";
    id: string;
    workspaceId: string;
    name: string;
    visibility: string;
    logo?: string | null;
    logoType?: string | null;
    color?: string | null;
    teamMembershipList: Array<{
      __typename?: "TeamMembership";
      id: string;
      userId: string;
      teamId: string;
      role: string;
      status: string;
      user?: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      } | null;
    }>;
  }>;
};

export type RequestTeamDeletionCodeQueryQueryVariables = Exact<{
  input: UpdateTeamInput;
}>;

export type RequestTeamDeletionCodeQueryQuery = {
  __typename?: "Query";
  requestTeamDeletionCode: { __typename?: "EmailStatus"; success: boolean; email: string; message: string };
};

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;

export type CreateTeamMutation = {
  __typename?: "Mutation";
  createTeam: {
    __typename?: "Team";
    id: string;
    workspaceId: string;
    name: string;
    visibility: string;
    logo?: string | null;
    logoType?: string | null;
    color?: string | null;
    teamMembershipList: Array<{
      __typename?: "TeamMembership";
      id: string;
      userId: string;
      teamId: string;
      role: string;
      status: string;
      user?: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      } | null;
    }>;
  };
};

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;

export type UpdateTeamMutation = {
  __typename?: "Mutation";
  updateTeam: {
    __typename?: "Team";
    id: string;
    workspaceId: string;
    name: string;
    visibility: string;
    logo?: string | null;
    logoType?: string | null;
    color?: string | null;
    teamMembershipList: Array<{
      __typename?: "TeamMembership";
      id: string;
      userId: string;
      teamId: string;
      role: string;
      status: string;
    }>;
  };
};

export type RemoveTeamMutationVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type RemoveTeamMutation = {
  __typename?: "Mutation";
  removeTeam: {
    __typename?: "Team";
    id: string;
    workspaceId: string;
    name: string;
    visibility: string;
    logo?: string | null;
    logoType?: string | null;
    color?: string | null;
    teamMembershipList: Array<{
      __typename?: "TeamMembership";
      id: string;
      userId: string;
      teamId: string;
      role: string;
      status: string;
    }>;
  };
};

export type Superuser_CreateTeamMembershipMutationVariables = Exact<{
  input: TeamMembershipCreateInput;
}>;

export type Superuser_CreateTeamMembershipMutation = {
  __typename?: "Mutation";
  superuser_createTeamMembership: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type Superuser_DeleteTeamMembershipMutationVariables = Exact<{
  input: TeamMembershipDeleteInput;
}>;

export type Superuser_DeleteTeamMembershipMutation = {
  __typename?: "Mutation";
  superuser_deleteTeamMembership: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type Superuser_UpdateTeamMembershipStatusMutationVariables = Exact<{
  input: TeamMembershipUpdateStatusInput;
}>;

export type Superuser_UpdateTeamMembershipStatusMutation = {
  __typename?: "Mutation";
  superuser_updateTeamMembershipStatus: {
    __typename?: "TeamMembership";
    id: string;
    userId: string;
    teamId: string;
    role: string;
    status: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type Superuser_TeamListForWorkspaceQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type Superuser_TeamListForWorkspaceQuery = {
  __typename?: "Query";
  superuser_teamListForWorkspace: Array<{
    __typename?: "Team";
    id: string;
    workspaceId: string;
    name: string;
    visibility: string;
    logo?: string | null;
    logoType?: string | null;
    color?: string | null;
    teamMembershipList: Array<{
      __typename?: "TeamMembership";
      id: string;
      userId: string;
      teamId: string;
      role: string;
      status: string;
      user?: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      } | null;
    }>;
  }>;
};

export type Superuser_CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;

export type Superuser_CreateTeamMutation = {
  __typename?: "Mutation";
  superuser_createTeam: {
    __typename?: "Team";
    id: string;
    workspaceId: string;
    name: string;
    visibility: string;
    logo?: string | null;
    logoType?: string | null;
    color?: string | null;
    teamMembershipList: Array<{
      __typename?: "TeamMembership";
      id: string;
      userId: string;
      teamId: string;
      role: string;
      status: string;
      user?: {
        __typename?: "User";
        id: string;
        email: string;
        username?: string | null;
        fullname?: string | null;
        profilePicture?: string | null;
      } | null;
    }>;
  };
};

export type GetUnitListQueryVariables = Exact<{
  input: GetUnitListInput;
}>;

export type GetUnitListQuery = {
  __typename?: "Query";
  unitList: Array<{
    __typename?: "Unit";
    id: string;
    workspaceId: string;
    title: string;
    symbol: string;
    keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
  }>;
};

export type GetUnitQueryVariables = Exact<{
  input: GetUnitInput;
}>;

export type GetUnitQuery = {
  __typename?: "Query";
  unit: {
    __typename?: "Unit";
    id: string;
    workspaceId: string;
    title: string;
    symbol: string;
    keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
  };
};

export type CreateUnitMutationVariables = Exact<{
  input: CreateUnitInput;
}>;

export type CreateUnitMutation = {
  __typename?: "Mutation";
  createUnit: {
    __typename?: "Unit";
    id: string;
    workspaceId: string;
    title: string;
    symbol: string;
    keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
  };
};

export type UpdateUnitMutationVariables = Exact<{
  input: UpdateUnitInput;
}>;

export type UpdateUnitMutation = {
  __typename?: "Mutation";
  updateUnit: {
    __typename?: "Unit";
    id: string;
    workspaceId: string;
    title: string;
    symbol: string;
    keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
  };
};

export type DeleteUnitMutationVariables = Exact<{
  input: DeleteUnitInput;
}>;

export type DeleteUnitMutation = {
  __typename?: "Mutation";
  deleteUnit: {
    __typename?: "Unit";
    id: string;
    workspaceId: string;
    title: string;
    symbol: string;
    keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
  };
};

export type AssigneeQueryVariables = Exact<{
  input: GetAssigneeInput;
}>;

export type AssigneeQuery = {
  __typename?: "Query";
  assignee: {
    __typename?: "Assignee";
    id: string;
    userId: string;
    workspaceId: string;
    ownerId: string;
    ownerType: string;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    };
  };
};

export type AssigneeByOwnerQueryVariables = Exact<{
  input: GetAssigneeListByOwnerInput;
}>;

export type AssigneeByOwnerQuery = {
  __typename?: "Query";
  assigneeByOwner?: {
    __typename?: "Assignee";
    id: string;
    userId: string;
    workspaceId: string;
    ownerId: string;
    ownerType: string;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    };
  } | null;
};

export type CreateAssigneeMutationVariables = Exact<{
  input: CreateAssigneeInput;
}>;

export type CreateAssigneeMutation = {
  __typename?: "Mutation";
  createAssignee: {
    __typename?: "Assignee";
    id: string;
    userId: string;
    workspaceId: string;
    ownerId: string;
    ownerType: string;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    };
  };
};

export type UpdateAssigneeMutationVariables = Exact<{
  input: UpdateAssigneeInput;
}>;

export type UpdateAssigneeMutation = {
  __typename?: "Mutation";
  updateAssignee: {
    __typename?: "Assignee";
    id: string;
    workspaceId: string;
    userId: string;
    ownerId: string;
    ownerType: string;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    };
  };
};

export type DeleteAssigneeMutationVariables = Exact<{
  input: DeleteAssigneeInput;
}>;

export type DeleteAssigneeMutation = {
  __typename?: "Mutation";
  deleteAssignee: {
    __typename?: "Assignee";
    id: string;
    userId: string;
    workspaceId: string;
    ownerId: string;
    ownerType: string;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    };
  };
};

export type GetUserFavoriteListQueryVariables = Exact<{
  getUserFavoriteListInput: UserFavoriteGetInput;
}>;

export type GetUserFavoriteListQuery = {
  __typename?: "Query";
  getUserFavoriteList: Array<{
    __typename?: "UserFavorite";
    id: string;
    userId: string;
    pageUrl: string;
    pageName: string;
    workspaceId: string;
  }>;
};

export type CreateUserFavoriteMutationVariables = Exact<{
  input: UserFavoriteCreateInput;
}>;

export type CreateUserFavoriteMutation = {
  __typename?: "Mutation";
  createUserFavorite: {
    __typename?: "UserFavorite";
    id: string;
    userId: string;
    pageUrl: string;
    pageName: string;
    workspaceId: string;
  };
};

export type DeleteUserFavoriteMutationVariables = Exact<{
  input: UserFavoriteDeleteInput;
}>;

export type DeleteUserFavoriteMutation = {
  __typename?: "Mutation";
  deleteUserFavorite: {
    __typename?: "UserFavorite";
    id: string;
    userId: string;
    pageUrl: string;
    pageName: string;
    workspaceId: string;
  };
};

export type RenameUserFavoriteMutationVariables = Exact<{
  input: UserFavoriteRenameInput;
}>;

export type RenameUserFavoriteMutation = {
  __typename?: "Mutation";
  renameUserFavorite: {
    __typename?: "UserFavorite";
    id: string;
    userId: string;
    pageUrl: string;
    pageName: string;
    workspaceId: string;
  };
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: "Query";
  currentUser: {
    __typename?: "User";
    id: string;
    email: string;
    fullname?: string | null;
    username?: string | null;
    profilePicture?: string | null;
    superUser: boolean;
    workspaceMembershipList?: Array<{
      __typename?: "WorkspaceMembership";
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      workspace?: {
        __typename?: "Workspace";
        id: string;
        name: string;
        workspaceUrl: string;
        logo?: string | null;
      } | null;
    }> | null;
  };
};

export type UserInWorkspaceQueryVariables = Exact<{
  input: UserGetInput;
}>;

export type UserInWorkspaceQuery = {
  __typename?: "Query";
  userInWorkspace: {
    __typename?: "User";
    id: string;
    email: string;
    fullname?: string | null;
    username?: string | null;
    profilePicture?: string | null;
    workspaceMembershipList?: Array<{
      __typename?: "WorkspaceMembership";
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      workspace?: {
        __typename?: "Workspace";
        id: string;
        name: string;
        workspaceUrl: string;
        logo?: string | null;
      } | null;
    }> | null;
  };
};

export type UpdateUserMutationVariables = Exact<{
  input: UserUpdateInput;
}>;

export type UpdateUserMutation = {
  __typename?: "Mutation";
  updateUser: {
    __typename?: "User";
    id: string;
    email: string;
    fullname?: string | null;
    username?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type UpdatePasswordMutationVariables = Exact<{
  input: PasswordUpdateInput;
}>;

export type UpdatePasswordMutation = {
  __typename?: "Mutation";
  updatePassword: {
    __typename?: "User";
    id: string;
    email: string;
    fullname?: string | null;
    username?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type GetActiveViewQueryVariables = Exact<{
  input: GetActiveViewInput;
}>;

export type GetActiveViewQuery = {
  __typename?: "Query";
  activeView?: {
    __typename?: "ActiveView";
    id: string;
    userId: string;
    workspaceId: string;
    key: string;
    showColumnHeaders: boolean;
    sectionColumnId?: string | null;
    subSectionColumnId?: string | null;
    globalFilter: string;
    columnOrder: Array<string>;
    columnVisibility: any;
    expanded: any;
    createdAt: any;
    updatedAt: any;
    columnFilters: Array<{ __typename?: "ColumnFilter"; id: string; value: any }>;
    sorting: Array<{ __typename?: "ColumnSort"; id: string; desc: boolean }>;
  } | null;
};

export type CreateActiveViewMutationVariables = Exact<{
  input: CreateActiveViewInput;
}>;

export type CreateActiveViewMutation = {
  __typename?: "Mutation";
  createActiveView: {
    __typename?: "ActiveView";
    id: string;
    userId: string;
    workspaceId: string;
    key: string;
    showColumnHeaders: boolean;
    sectionColumnId?: string | null;
    subSectionColumnId?: string | null;
    globalFilter: string;
    columnOrder: Array<string>;
    columnVisibility: any;
    expanded: any;
    createdAt: any;
    updatedAt: any;
    columnFilters: Array<{ __typename?: "ColumnFilter"; id: string; value: any }>;
    sorting: Array<{ __typename?: "ColumnSort"; id: string; desc: boolean }>;
  };
};

export type UpdateActiveViewMutationVariables = Exact<{
  input: UpdateActiveViewInput;
}>;

export type UpdateActiveViewMutation = {
  __typename?: "Mutation";
  updateActiveView: {
    __typename?: "ActiveView";
    id: string;
    userId: string;
    workspaceId: string;
    key: string;
    showColumnHeaders: boolean;
    sectionColumnId?: string | null;
    subSectionColumnId?: string | null;
    globalFilter: string;
    columnOrder: Array<string>;
    columnVisibility: any;
    expanded: any;
    createdAt: any;
    updatedAt: any;
    columnFilters: Array<{ __typename?: "ColumnFilter"; id: string; value: any }>;
    sorting: Array<{ __typename?: "ColumnSort"; id: string; desc: boolean }>;
  };
};

export type WorkspaceMembershipListForWorkspaceQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type WorkspaceMembershipListForWorkspaceQuery = {
  __typename?: "Query";
  workspaceMembershipListForWorkspace: Array<{
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  }>;
};

export type FindWorkspaceInviteQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type FindWorkspaceInviteQuery = {
  __typename?: "Query";
  findWorkspaceInvite: {
    __typename?: "WorkspaceInvite";
    userId: string;
    workspaceId: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
      activated: boolean;
    } | null;
    workspace?: {
      __typename?: "Workspace";
      id: string;
      name: string;
      workspaceUrl: string;
      logo?: string | null;
    } | null;
  };
};

export type UpdateWorkspaceMembershipRoleMutationVariables = Exact<{
  input: WorkspaceMembershipUpdateRoleInput;
}>;

export type UpdateWorkspaceMembershipRoleMutation = {
  __typename?: "Mutation";
  updateWorkspaceMembershipRole: {
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type UpdateWorkspaceMembershipStatusMutationVariables = Exact<{
  input: WorkspaceMembershipUpdateStatusInput;
}>;

export type UpdateWorkspaceMembershipStatusMutation = {
  __typename?: "Mutation";
  updateWorkspaceMembershipStatus: {
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type LeaveWorkspaceMembershipMutationVariables = Exact<{
  input: WorkspaceMembershipLeaveInput;
}>;

export type LeaveWorkspaceMembershipMutation = {
  __typename?: "Mutation";
  leaveWorkspaceMembership: {
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type RejoinWorkspaceMembershipMutationVariables = Exact<{
  input: WorkspaceMembershipRejoinInput;
}>;

export type RejoinWorkspaceMembershipMutation = {
  __typename?: "Mutation";
  rejoinWorkspaceMembership: {
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
  };
};

export type CreateWorkspaceInviteMutationVariables = Exact<{
  input: WorkspaceInviteCreateWithEmailInput;
}>;

export type CreateWorkspaceInviteMutation = {
  __typename?: "Mutation";
  createWorkspaceInvite: {
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
    user?: { __typename?: "User"; id: string; email: string } | null;
  };
};

export type AcceptWorkspaceInviteMutationVariables = Exact<{
  input: WorkspaceInviteAcceptInput;
}>;

export type AcceptWorkspaceInviteMutation = {
  __typename?: "Mutation";
  acceptWorkspaceInvite: {
    __typename?: "WorkspaceInvite";
    userId: string;
    workspaceId: string;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
      activated: boolean;
    } | null;
    workspace?: {
      __typename?: "Workspace";
      id: string;
      name: string;
      workspaceUrl: string;
      logo?: string | null;
    } | null;
  };
};

export type DeleteWorkspaceInviteMutationVariables = Exact<{
  input: WorkspaceInviteDeleteInput;
}>;

export type DeleteWorkspaceInviteMutation = {
  __typename?: "Mutation";
  deleteWorkspaceInvitation: { __typename?: "WorkspaceMembership"; userId: string; workspaceId: string };
};

export type ResendWorkspaceInviteNotificationMutationVariables = Exact<{
  input: WorkspaceInviteUpdateInput;
}>;

export type ResendWorkspaceInviteNotificationMutation = {
  __typename?: "Mutation";
  resendWorkspaceInviteNotification: { __typename?: "WorkspaceMembership"; userId: string; workspaceId: string };
};

export type WorkspaceByUrlQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type WorkspaceByUrlQuery = {
  __typename?: "Query";
  workspaceByUrl: {
    __typename?: "Workspace";
    id: string;
    name: string;
    workspaceUrl: string;
    logo?: string | null;
    updatedAt: any;
    createdAt: any;
    phaseList: Array<{
      __typename?: "Phase";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
    }>;
    priorityList: Array<{
      __typename?: "Priority";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
    }>;
    unitList: Array<{
      __typename?: "Unit";
      id: string;
      workspaceId: string;
      title: string;
      symbol: string;
      keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
    }>;
    focusAreaList: Array<{
      __typename?: "FocusArea";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
    }>;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      labelGroupId?: string | null;
      workspaceId: string;
      instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
    }>;
    labelGroupList: Array<{
      __typename?: "LabelGroup";
      id: string;
      title: string;
      color: string;
      allowMultiSelect: boolean;
      workspaceId: string;
      labelList: Array<{
        __typename?: "Label";
        id: string;
        title: string;
        color: string;
        labelGroupId?: string | null;
      }>;
    }>;
    workspaceMembershipList: Array<{
      __typename?: "WorkspaceMembership";
      id: string;
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      updatedAt: any;
      createdAt: any;
    }>;
    activeViewList: Array<{
      __typename?: "ActiveView";
      id: string;
      userId: string;
      workspaceId: string;
      key: string;
      showColumnHeaders: boolean;
      sectionColumnId?: string | null;
      subSectionColumnId?: string | null;
      globalFilter: string;
      columnOrder: Array<string>;
      columnVisibility: any;
      expanded: any;
      createdAt: any;
      updatedAt: any;
      columnFilters: Array<{ __typename?: "ColumnFilter"; id: string; value: any }>;
      sorting: Array<{ __typename?: "ColumnSort"; id: string; desc: boolean }>;
    }>;
  };
};

export type WorkspaceByIdQueryVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type WorkspaceByIdQuery = {
  __typename?: "Query";
  workspaceById: {
    __typename?: "Workspace";
    id: string;
    name: string;
    workspaceUrl: string;
    logo?: string | null;
    updatedAt: any;
    createdAt: any;
    phaseList: Array<{
      __typename?: "Phase";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
    }>;
    priorityList: Array<{
      __typename?: "Priority";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
    }>;
    unitList: Array<{
      __typename?: "Unit";
      id: string;
      workspaceId: string;
      title: string;
      symbol: string;
      keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
    }>;
    focusAreaList: Array<{
      __typename?: "FocusArea";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
    }>;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      workspaceId: string;
      labelGroupId?: string | null;
      instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
    }>;
    labelGroupList: Array<{
      __typename?: "LabelGroup";
      id: string;
      title: string;
      color: string;
      allowMultiSelect: boolean;
      workspaceId: string;
      labelList: Array<{
        __typename?: "Label";
        id: string;
        title: string;
        color: string;
        workspaceId: string;
        labelGroupId?: string | null;
      }>;
    }>;
    workspaceMembershipList: Array<{
      __typename?: "WorkspaceMembership";
      id: string;
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      updatedAt: any;
      createdAt: any;
    }>;
    activeViewList: Array<{
      __typename?: "ActiveView";
      id: string;
      userId: string;
      workspaceId: string;
      key: string;
      showColumnHeaders: boolean;
      sectionColumnId?: string | null;
      subSectionColumnId?: string | null;
      globalFilter: string;
      columnOrder: Array<string>;
      columnVisibility: any;
      expanded: any;
      createdAt: any;
      updatedAt: any;
      columnFilters: Array<{ __typename?: "ColumnFilter"; id: string; value: any }>;
      sorting: Array<{ __typename?: "ColumnSort"; id: string; desc: boolean }>;
    }>;
  };
};

export type UpdateWorkspaceMutationVariables = Exact<{
  input: WorkspaceUpdateInput;
}>;

export type UpdateWorkspaceMutation = {
  __typename?: "Mutation";
  updateWorkspace: {
    __typename?: "Workspace";
    id: string;
    name: string;
    workspaceUrl: string;
    logo?: string | null;
    updatedAt: any;
    createdAt: any;
    phaseList: Array<{
      __typename?: "Phase";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
    }>;
    priorityList: Array<{
      __typename?: "Priority";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
    }>;
    unitList: Array<{
      __typename?: "Unit";
      id: string;
      workspaceId: string;
      title: string;
      symbol: string;
      keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
    }>;
    focusAreaList: Array<{
      __typename?: "FocusArea";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "FocusAreaInstance"; id: string }>;
    }>;
    labelList: Array<{
      __typename?: "Label";
      id: string;
      title: string;
      color: string;
      labelGroupId?: string | null;
      workspaceId: string;
      instanceList: Array<{ __typename?: "LabelInstance"; id: string }>;
    }>;
    labelGroupList: Array<{
      __typename?: "LabelGroup";
      id: string;
      title: string;
      color: string;
      allowMultiSelect: boolean;
      workspaceId: string;
      labelList: Array<{
        __typename?: "Label";
        id: string;
        title: string;
        color: string;
        labelGroupId?: string | null;
      }>;
    }>;
    workspaceMembershipList: Array<{
      __typename?: "WorkspaceMembership";
      id: string;
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      updatedAt: any;
      createdAt: any;
    }>;
    activeViewList: Array<{
      __typename?: "ActiveView";
      id: string;
      userId: string;
      workspaceId: string;
      key: string;
      showColumnHeaders: boolean;
      sectionColumnId?: string | null;
      subSectionColumnId?: string | null;
      globalFilter: string;
      columnOrder: Array<string>;
      columnVisibility: any;
      expanded: any;
      createdAt: any;
      updatedAt: any;
      columnFilters: Array<{ __typename?: "ColumnFilter"; id: string; value: any }>;
      sorting: Array<{ __typename?: "ColumnSort"; id: string; desc: boolean }>;
    }>;
  };
};

export type DeleteWorkspaceMutationVariables = Exact<{
  input: WorkspaceDeleteInput;
}>;

export type DeleteWorkspaceMutation = {
  __typename?: "Mutation";
  deleteWorkspace: {
    __typename?: "Workspace";
    id: string;
    name: string;
    workspaceUrl: string;
    logo?: string | null;
    createdAt: any;
    updatedAt: any;
  };
};

export type SendWorkspaceDeleteCodeEmailMutationVariables = Exact<{
  input: WorkspaceDeleteCodeCreateInput;
}>;

export type SendWorkspaceDeleteCodeEmailMutation = {
  __typename?: "Mutation";
  sendWorkspaceDeleteCodeEmail: { __typename?: "EmailStatus"; success: boolean; email: string; message: string };
};

export type Superuser_DeleteWorkspaceMembershipMutationVariables = Exact<{
  input: WorkspaceMembershipDeleteInput;
}>;

export type Superuser_DeleteWorkspaceMembershipMutation = {
  __typename?: "Mutation";
  superuser_deleteWorkspaceMembership: {
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type Superuser_CreateWorkspaceMembershipMutationVariables = Exact<{
  input: WorkspaceMembershipCreateInput;
}>;

export type Superuser_CreateWorkspaceMembershipMutation = {
  __typename?: "Mutation";
  superuser_createWorkspaceMembership: {
    __typename?: "WorkspaceMembership";
    userId: string;
    workspaceId: string;
    role: string;
    status: string;
    updatedAt: any;
    createdAt: any;
    user?: {
      __typename?: "User";
      id: string;
      email: string;
      username?: string | null;
      fullname?: string | null;
      profilePicture?: string | null;
    } | null;
  };
};

export type Superuser_WorkspaceListQueryVariables = Exact<{ [key: string]: never }>;

export type Superuser_WorkspaceListQuery = {
  __typename?: "Query";
  superuser_workspaceList: Array<{
    __typename?: "Workspace";
    id: string;
    name: string;
    workspaceUrl: string;
    logo?: string | null;
    updatedAt: any;
    createdAt: any;
    workspaceMembershipList: Array<{
      __typename?: "WorkspaceMembership";
      id: string;
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      updatedAt: any;
      createdAt: any;
    }>;
    priorityList: Array<{
      __typename?: "Priority";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
    }>;
    phaseList: Array<{
      __typename?: "Phase";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
    }>;
  }>;
};

export type Superuser_CreateWorkspaceMutationVariables = Exact<{
  input: WorkspaceCreateInput;
}>;

export type Superuser_CreateWorkspaceMutation = {
  __typename?: "Mutation";
  superuser_createWorkspace: {
    __typename?: "Workspace";
    id: string;
    name: string;
    workspaceUrl: string;
    logo?: string | null;
    createdAt: any;
    updatedAt: any;
    workspaceMembershipList: Array<{
      __typename?: "WorkspaceMembership";
      id: string;
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      updatedAt: any;
      createdAt: any;
    }>;
    phaseList: Array<{
      __typename?: "Phase";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
    }>;
    unitList: Array<{
      __typename?: "Unit";
      id: string;
      workspaceId: string;
      title: string;
      symbol: string;
      keyResults: Array<{ __typename?: "KeyResult"; id: string; climateActionId: string }>;
    }>;
  };
};

export type Superuser_DuplicateWorkspaceMutationVariables = Exact<{
  input: WorkspaceDuplicateInput;
}>;

export type Superuser_DuplicateWorkspaceMutation = {
  __typename?: "Mutation";
  superuser_duplicateWorkspace: {
    __typename?: "Workspace";
    id: string;
    name: string;
    workspaceUrl: string;
    logo?: string | null;
    createdAt: any;
    updatedAt: any;
    workspaceMembershipList: Array<{
      __typename?: "WorkspaceMembership";
      id: string;
      userId: string;
      workspaceId: string;
      role: string;
      status: string;
      updatedAt: any;
      createdAt: any;
    }>;
    priorityList: Array<{
      __typename?: "Priority";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PriorityInstance"; id: string }>;
    }>;
    phaseList: Array<{
      __typename?: "Phase";
      id: string;
      workspaceId: string;
      name: string;
      color: string;
      type: string;
      instanceList: Array<{ __typename?: "PhaseInstance"; id: string }>;
    }>;
  };
};

export const LoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "login" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoginInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "login" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "loginInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "token" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RefreshDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "refresh" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refresh" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "token" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshMutation, RefreshMutationVariables>;
export const RequestPasswordResetLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requestPasswordResetLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "PasswordResetLinkRequestInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestPasswordResetLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordResetLinkRequestInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>;
export const CheckPasswordResetTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "checkPasswordResetToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "PasswordResetTokenCheckInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkPasswordResetToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordResetTokenCheckInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckPasswordResetTokenMutation, CheckPasswordResetTokenMutationVariables>;
export const UpdatePasswordWithTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePasswordWithToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "PasswordUpdateWithTokenInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePasswordWithToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordUpdateWithTokenInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePasswordWithTokenMutation, UpdatePasswordWithTokenMutationVariables>;
export const GetFeatureFlagDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFeatureFlag" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "getFeatureFlagInput" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetFeatureFlagInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "featureFlag" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getFeatureFlagInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "getFeatureFlagInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "payload" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>;
export const GetFeatureFlagListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFeatureFlagList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "getFeatureFlagListInput" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetFeatureFlagListInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "featureFlagList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getFeatureFlagListInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "getFeatureFlagListInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                { kind: "Field", name: { kind: "Name", value: "payload" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeatureFlagListQuery, GetFeatureFlagListQueryVariables>;
export const FileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "file" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileGetInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "file" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileGetInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileQuery, FileQueryVariables>;
export const FileListForOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fileListForOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "FileListGetByOwnerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fileListForOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileListGetByOwnerInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileListForOwnerQuery, FileListForOwnerQueryVariables>;
export const CreateFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileCreateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFileMutation, CreateFileMutationVariables>;
export const UpdateFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileUpdateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFileMutation, UpdateFileMutationVariables>;
export const ReplaceFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "replaceFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileReplaceInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "replaceFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileReplaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReplaceFileMutation, ReplaceFileMutationVariables>;
export const DeleteFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "FileDeleteInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileDeleteInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFileMutation, DeleteFileMutationVariables>;
export const CreateDownloadLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createDownloadLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DownloadLinkCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createDownloadLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "downloadLinkCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDownloadLinkMutation, CreateDownloadLinkMutationVariables>;
export const CreateSignedUploadUrlMutationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createSignedUploadUrlMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "SignedUploadUrlCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createSignedUploadUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "signedUploadUrlCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "permaUrl" } },
                { kind: "Field", name: { kind: "Name", value: "signedUrl" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSignedUploadUrlMutationMutation, CreateSignedUploadUrlMutationMutationVariables>;
export const MakeFileAccessibleToPublicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "makeFileAccessibleToPublic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "MakeFileAccessibleToPublicInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "makeFileAccessibleToPublic" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "makeFileAccessibleToPublicInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MakeFileAccessibleToPublicMutation, MakeFileAccessibleToPublicMutationVariables>;
export const CheckPermissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "checkPermission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CheckPermissionInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkPermission" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "checkPermissionInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "hasPermission" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckPermissionQuery, CheckPermissionQueryVariables>;
export const CheckPermissionListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "checkPermissionList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CheckPermissionsInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkPermissionList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "checkPermissionsInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "hasPermission" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckPermissionListQuery, CheckPermissionListQueryVariables>;
export const GetSavedViewsByUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSavedViewsByUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetSavedViewsByUrlInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "savedViews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getSavedViewsByUrlInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tableConfiguration" } },
                { kind: "Field", name: { kind: "Name", value: "isBaseView" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSavedViewsByUrlQuery, GetSavedViewsByUrlQueryVariables>;
export const GetSavedViewListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSavedViewListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetSavedViewsForWorkspaceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "savedViewListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getSavedViewsForWorkspaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tableConfiguration" } },
                { kind: "Field", name: { kind: "Name", value: "isBaseView" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSavedViewListForWorkspaceQuery, GetSavedViewListForWorkspaceQueryVariables>;
export const CreateSavedViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSavedView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateSavedViewInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createSavedView" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createSavedViewInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tableConfiguration" } },
                { kind: "Field", name: { kind: "Name", value: "isBaseView" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSavedViewMutation, CreateSavedViewMutationVariables>;
export const UpdateSavedViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSavedView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateSavedViewInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateSavedView" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateSavedViewInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tableConfiguration" } },
                { kind: "Field", name: { kind: "Name", value: "isBaseView" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>;
export const DeleteSavedViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSavedView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteSavedViewInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSavedView" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "tableConfiguration" } },
                { kind: "Field", name: { kind: "Name", value: "isBaseView" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSavedViewMutation, DeleteSavedViewMutationVariables>;
export const GetClimateActionListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClimateActionListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetClimateActionListForWorkspaceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "climateActionListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getClimateActionListForWorkspaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "unitId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                      { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                      { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unit" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "symbol" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressSnapshotList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "labelId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "label" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusAreaInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "focusArea" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClimateActionListForWorkspaceQuery, GetClimateActionListForWorkspaceQueryVariables>;
export const GetClimateActionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClimateAction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetClimateActionInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "climateAction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getClimateActionInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "unitId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                      { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                      { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unit" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "symbol" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressSnapshotList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "labelId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "label" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusAreaInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "focusArea" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClimateActionQuery, GetClimateActionQueryVariables>;
export const CreateClimateActionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createClimateAction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateClimateActionInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createClimateAction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createClimateActionInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "unitId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                      { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                      { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unit" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "symbol" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressSnapshotList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "labelId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "label" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusAreaInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "focusArea" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClimateActionMutation, CreateClimateActionMutationVariables>;
export const UpdateClimateActionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateClimateAction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateClimateActionInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateClimateAction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateClimateActionInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "children" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      { kind: "Field", name: { kind: "Name", value: "parentId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "unitId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                      { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                      { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                      { kind: "Field", name: { kind: "Name", value: "startDate" } },
                      { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unit" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "symbol" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progressSnapshotList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                      { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                      { kind: "Field", name: { kind: "Name", value: "properties" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phase" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "labelId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "label" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusAreaInstance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "focusArea" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamInstanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                      { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClimateActionMutation, UpdateClimateActionMutationVariables>;
export const DeleteClimateActionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteClimateAction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteClimateActionInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteClimateAction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteClimateActionInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClimateActionMutation, DeleteClimateActionMutationVariables>;
export const GetFocusAreaInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFocusAreaInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetFocusAreaInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "focusAreaInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getFocusAreaInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusArea" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFocusAreaInstanceQuery, GetFocusAreaInstanceQueryVariables>;
export const GetFocusAreaInstanceByOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFocusAreaInstanceByOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetFocusAreaInstanceByOwnerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "focusAreaInstanceByOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getFocusAreaInstanceByOwnerInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusArea" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFocusAreaInstanceByOwnerQuery, GetFocusAreaInstanceByOwnerQueryVariables>;
export const CreateFocusAreaInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createFocusAreaInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateFocusAreaInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFocusAreaInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createFocusAreaInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusArea" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFocusAreaInstanceMutation, CreateFocusAreaInstanceMutationVariables>;
export const UpdateFocusAreaInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateFocusAreaInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateFocusAreaInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateFocusAreaInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateFocusAreaInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusArea" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFocusAreaInstanceMutation, UpdateFocusAreaInstanceMutationVariables>;
export const DeleteFocusAreaInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteFocusAreaInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteFocusAreaInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFocusAreaInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteFocusAreaInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "focusAreaId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusArea" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFocusAreaInstanceMutation, DeleteFocusAreaInstanceMutationVariables>;
export const GetFocusAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFocusArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetFocusAreaInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "focusArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getFocusAreaInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFocusAreaQuery, GetFocusAreaQueryVariables>;
export const GetFocusAreaListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFocusAreaListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetFocusAreaListForWorkspaceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "focusAreaListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getFocusAreaListForWorkspaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFocusAreaListForWorkspaceQuery, GetFocusAreaListForWorkspaceQueryVariables>;
export const CreateFocusAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createFocusArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateFocusAreaInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createFocusArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createFocusAreaInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFocusAreaMutation, CreateFocusAreaMutationVariables>;
export const UpdateFocusAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateFocusArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateFocusAreaInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateFocusArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateFocusAreaInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFocusAreaMutation, UpdateFocusAreaMutationVariables>;
export const DeleteFocusAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteFocusArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteFocusAreaInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFocusArea" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteFocusAreaInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFocusAreaMutation, DeleteFocusAreaMutationVariables>;
export const GetIndicatorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIndicator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetIndicatorInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "indicator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getIndicatorInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "comment" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "valueCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latestValue" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "comment" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIndicatorQuery, GetIndicatorQueryVariables>;
export const GetIndicatorListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIndicatorList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetIndicatorListInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "indicatorList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getIndicatorListInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "valueCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latestValue" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "comment" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIndicatorListQuery, GetIndicatorListQueryVariables>;
export const CreateIndicatorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateIndicator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateIndicatorInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createIndicator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createIndicatorInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "comment" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "valueCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latestValue" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "comment" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIndicatorMutation, CreateIndicatorMutationVariables>;
export const UpdateIndicatorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateIndicator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateIndicatorInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateIndicator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateIndicatorInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "comment" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "valueCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latestValue" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      { kind: "Field", name: { kind: "Name", value: "comment" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;
export const DeleteIndicatorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteIndicator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteIndicatorInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteIndicator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteIndicatorInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>;
export const CreateIndicatorValueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateIndicatorValue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateIndicatorValueInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createIndicatorValue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createIndicatorValueInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIndicatorValueMutation, CreateIndicatorValueMutationVariables>;
export const UpdateIndicatorValueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateIndicatorValue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateIndicatorValueInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateIndicatorValue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateIndicatorValueInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateIndicatorValueMutation, UpdateIndicatorValueMutationVariables>;
export const DeleteIndicatorValueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteIndicatorValue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteIndicatorValueInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteIndicatorValue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteIndicatorValueInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "indicatorId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteIndicatorValueMutation, DeleteIndicatorValueMutationVariables>;
export const GetKeyResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetKeyResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetKeyResultInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "keyResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getKeyResultInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetKeyResultQuery, GetKeyResultQueryVariables>;
export const CreateKeyResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createKeyResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateKeyResultInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createKeyResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createKeyResultInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateKeyResultMutation, CreateKeyResultMutationVariables>;
export const UpdateKeyResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateKeyResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateKeyResultInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateKeyResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateKeyResultInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>;
export const DeleteKeyResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteKeyResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteKeyResultInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteKeyResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteKeyResultInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                { kind: "Field", name: { kind: "Name", value: "unitId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "initialValue" } },
                { kind: "Field", name: { kind: "Name", value: "targetValue" } },
                { kind: "Field", name: { kind: "Name", value: "currentValue" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "targetDate" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unit" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteKeyResultMutation, DeleteKeyResultMutationVariables>;
export const GetLabelGroupListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLabelGroupListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetLabelGroupListForWorkspaceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labelGroupListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getLabelGroupListForWorkspaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLabelGroupListForWorkspaceQuery, GetLabelGroupListForWorkspaceQueryVariables>;
export const GetLabelGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLabelGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetLabelGroupInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labelGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getLabelGroupInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLabelGroupQuery, GetLabelGroupQueryVariables>;
export const CreateLabelGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createLabelGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateLabelGroupInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLabelGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createLabelGroupInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLabelGroupMutation, CreateLabelGroupMutationVariables>;
export const UpdateLabelGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateLabelGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateLabelGroupInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLabelGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateLabelGroupInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLabelGroupMutation, UpdateLabelGroupMutationVariables>;
export const DeleteLabelGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteLabelGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteLabelGroupInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLabelGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteLabelGroupInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteLabelGroupMutation, DeleteLabelGroupMutationVariables>;
export const GetLabelInstanceListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLabelInstanceList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetLabelInstanceListInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labelInstanceList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getLabelInstanceListInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "labelId" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "label" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLabelInstanceListQuery, GetLabelInstanceListQueryVariables>;
export const GetLabelInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLabelInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetLabelInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labelInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getLabelInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "labelId" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "label" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLabelInstanceQuery, GetLabelInstanceQueryVariables>;
export const CreateLabelInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createLabelInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateLabelInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLabelInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createLabelInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "labelId" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "label" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLabelInstanceMutation, CreateLabelInstanceMutationVariables>;
export const DeleteLabelInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteLabelInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteLabelInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLabelInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteLabelInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "labelId" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "label" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteLabelInstanceMutation, DeleteLabelInstanceMutationVariables>;
export const GetLabelListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLabelListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetLabelListForWorkspaceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "labelListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getLabelListForWorkspaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLabelListForWorkspaceQuery, GetLabelListForWorkspaceQueryVariables>;
export const GetLabelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLabel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GetLabelInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "label" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getLabelInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLabelQuery, GetLabelQueryVariables>;
export const CreateLabelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createLabel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreateLabelInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLabel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createLabelInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLabelMutation, CreateLabelMutationVariables>;
export const UpdateLabelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateLabel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateLabelInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLabel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateLabelInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLabelMutation, UpdateLabelMutationVariables>;
export const DeleteLabelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteLabel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DeleteLabelInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLabel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteLabelInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteLabelMutation, DeleteLabelMutationVariables>;
export const GetPhaseInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPhaseInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetPhaseInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "phaseInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPhaseInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPhaseInstanceQuery, GetPhaseInstanceQueryVariables>;
export const GetPhaseInstanceByOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPhaseInstanceByOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetPhaseInstanceByOwnerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "phaseInstanceByOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPhaseInstanceByOwnerInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPhaseInstanceByOwnerQuery, GetPhaseInstanceByOwnerQueryVariables>;
export const CreatePhaseInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPhaseInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreatePhaseInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPhaseInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createPhaseInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePhaseInstanceMutation, CreatePhaseInstanceMutationVariables>;
export const UpdatePhaseInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePhaseInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdatePhaseInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePhaseInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePhaseInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePhaseInstanceMutation, UpdatePhaseInstanceMutationVariables>;
export const DeletePhaseInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeletePhaseInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeletePhaseInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePhaseInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deletePhaseInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "phaseId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phase" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePhaseInstanceMutation, DeletePhaseInstanceMutationVariables>;
export const GetPhaseListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPhaseListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetPhaseListForWorkspaceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "phaseListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPhaseListForWorkspaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPhaseListForWorkspaceQuery, GetPhaseListForWorkspaceQueryVariables>;
export const GetPhaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPhase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GetPhaseInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "phase" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPhaseInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPhaseQuery, GetPhaseQueryVariables>;
export const CreatePhaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPhase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreatePhaseInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPhase" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createPhaseInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePhaseMutation, CreatePhaseMutationVariables>;
export const UpdatePhaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdatePhase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdatePhaseInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePhase" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePhaseInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePhaseMutation, UpdatePhaseMutationVariables>;
export const DeletePhaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeletePhase" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DeletePhaseInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePhase" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deletePhaseInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePhaseMutation, DeletePhaseMutationVariables>;
export const GetPriorityInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPriorityInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetPriorityInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "priorityInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPriorityInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPriorityInstanceQuery, GetPriorityInstanceQueryVariables>;
export const GetPriorityInstanceByOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPriorityInstanceByOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetPriorityInstanceByOwnerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "priorityInstanceByOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPriorityInstanceByOwnerInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPriorityInstanceByOwnerQuery, GetPriorityInstanceByOwnerQueryVariables>;
export const CreatePriorityInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPriorityInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreatePriorityInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPriorityInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createPriorityInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priority" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePriorityInstanceMutation, CreatePriorityInstanceMutationVariables>;
export const UpdatePriorityInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePriorityInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdatePriorityInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePriorityInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePriorityInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priority" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePriorityInstanceMutation, UpdatePriorityInstanceMutationVariables>;
export const DeletePriorityInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeletePriorityInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeletePriorityInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePriorityInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deletePriorityInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "priorityId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priority" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePriorityInstanceMutation, DeletePriorityInstanceMutationVariables>;
export const GetPriorityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPriority" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GetPriorityInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "priority" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPriorityInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPriorityQuery, GetPriorityQueryVariables>;
export const GetPriorityListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPriorityListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetPriorityListForWorkspaceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "priorityListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getPriorityListForWorkspaceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPriorityListForWorkspaceQuery, GetPriorityListForWorkspaceQueryVariables>;
export const CreatePriorityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPriority" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreatePriorityInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPriority" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createPriorityInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePriorityMutation, CreatePriorityMutationVariables>;
export const UpdatePriorityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdatePriority" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdatePriorityInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePriority" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePriorityInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePriorityMutation, UpdatePriorityMutationVariables>;
export const DeletePriorityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeletePriority" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeletePriorityInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePriority" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deletePriorityInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "instanceList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePriorityMutation, DeletePriorityMutationVariables>;
export const GetProgressSnapshotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProgressSnapshot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetProgressSnapshotInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "progressSnapshot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getProgressSnapshotInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProgressSnapshotQuery, GetProgressSnapshotQueryVariables>;
export const GetProgressSnapshotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProgressSnapshots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetProgressSnapshotsInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "progressSnapshots" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getProgressSnapshotsInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProgressSnapshotsQuery, GetProgressSnapshotsQueryVariables>;
export const GetProgressSnapshotsForKeyResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProgressSnapshotsForKeyResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetProgressSnapshotsForKeyResultInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "progressSnapshotsForKeyResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getProgressSnapshotsForKeyResultInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProgressSnapshotsForKeyResultsQuery, GetProgressSnapshotsForKeyResultsQueryVariables>;
export const CreateProgressSnapshotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createProgressSnapshot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateProgressSnapshotInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createProgressSnapshot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createProgressSnapshotInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProgressSnapshotMutation, CreateProgressSnapshotMutationVariables>;
export const DeleteProgressSnapshotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteProgressSnapshot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteProgressSnapshotInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProgressSnapshot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteProgressSnapshotInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "keyResultId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "snapshotDate" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteProgressSnapshotMutation, DeleteProgressSnapshotMutationVariables>;
export const GetAllTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetAllTaskListInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAllTasks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getAllTaskListForUserInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllTasksQuery, GetAllTasksQueryVariables>;
export const UpdateTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateTaskInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateTaskInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateTaskListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTaskList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateTaskListInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTaskList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateTaskListInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskListMutation, UpdateTaskListMutationVariables>;
export const CreateTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreateTaskInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createTaskInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskMutation, CreateTaskMutationVariables>;
export const DeleteTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteTaskByIdInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteTaskByIdInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const GetTeamInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTeamInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "getTeamInstanceInput" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetTeamInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getTeamInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "getTeamInstanceInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeamInstanceQuery, GetTeamInstanceQueryVariables>;
export const GetTeamInstanceByOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTeamInstanceByOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "getTeamInstanceByOwnerInput" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetTeamInstanceByOwnerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamInstanceByOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getTeamInstanceByOwnerInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "getTeamInstanceByOwnerInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeamInstanceByOwnerQuery, GetTeamInstanceByOwnerQueryVariables>;
export const CreateTeamInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createTeamInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateTeamInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTeamInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createTeamInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTeamInstanceMutation, CreateTeamInstanceMutationVariables>;
export const UpdateTeamInstanceListForOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTeamInstanceListForOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateTeamInstanceListForOwnerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTeamInstanceListForOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateTeamInstanceListForOwnerInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTeamInstanceListForOwnerMutation, UpdateTeamInstanceListForOwnerMutationVariables>;
export const DeleteTeamInstanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTeamInstance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteTeamInstanceInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTeamInstance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteTeamInstanceInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTeamInstanceMutation, DeleteTeamInstanceMutationVariables>;
export const TeamMembershipListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "teamMembershipList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamMembershipList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamId" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamMembershipListQuery, TeamMembershipListQueryVariables>;
export const FindTeamInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "findTeamInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "findTeamInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "pendingWorkspaceMembership" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                      { kind: "Field", name: { kind: "Name", value: "activated" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "team" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "visibility" } },
                      { kind: "Field", name: { kind: "Name", value: "logo" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workspace" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "logo" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindTeamInviteQuery, FindTeamInviteQueryVariables>;
export const UpdateTeamMembershipRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateTeamMembershipRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipUpdateRoleInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTeamMembershipRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipUpdateRoleInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTeamMembershipRoleMutation, UpdateTeamMembershipRoleMutationVariables>;
export const UpdateTeamMembershipStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateTeamMembershipStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipUpdateStatusInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTeamMembershipStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipUpdateStatusInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTeamMembershipStatusMutation, UpdateTeamMembershipStatusMutationVariables>;
export const LeaveTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "leaveTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipLeaveInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leaveTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipLeaveInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeaveTeamMutation, LeaveTeamMutationVariables>;
export const RejoinTeamMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "rejoinTeamMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipRejoinInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rejoinTeamMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipRejoinInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RejoinTeamMembershipMutation, RejoinTeamMembershipMutationVariables>;
export const CreateTeamInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createTeamInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamInviteCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTeamInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamInviteCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTeamInviteMutation, CreateTeamInviteMutationVariables>;
export const AcceptTeamInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "acceptTeamInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamInviteAcceptInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptTeamInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamInviteAcceptInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptTeamInviteMutation, AcceptTeamInviteMutationVariables>;
export const DeleteTeamInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTeamInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamInviteDeleteInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTeamInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamInviteDeleteInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTeamInviteMutation, DeleteTeamInviteMutationVariables>;
export const ResendTeamInviteNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resendTeamInviteNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamInviteUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resendTeamInviteNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamInviteUpdateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendTeamInviteNotificationMutation, ResendTeamInviteNotificationMutationVariables>;
export const JoinTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "joinTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipJoinInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "joinTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipJoinInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JoinTeamMutation, JoinTeamMutationVariables>;
export const TeamByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "teamById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamId" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "logoType" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamByIdQuery, TeamByIdQueryVariables>;
export const TeamListForWorkspaceQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "teamListForWorkspaceQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceId" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "logoType" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamListForWorkspaceQueryQuery, TeamListForWorkspaceQueryQueryVariables>;
export const RequestTeamDeletionCodeQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "requestTeamDeletionCodeQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateTeamInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestTeamDeletionCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateTeamInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestTeamDeletionCodeQueryQuery, RequestTeamDeletionCodeQueryQueryVariables>;
export const CreateTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreateTeamInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createTeamInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "logoType" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateTeamInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateTeamInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "logoType" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const RemoveTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "logoType" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveTeamMutation, RemoveTeamMutationVariables>;
export const Superuser_CreateTeamMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_createTeamMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_createTeamMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Superuser_CreateTeamMembershipMutation, Superuser_CreateTeamMembershipMutationVariables>;
export const Superuser_DeleteTeamMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_deleteTeamMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipDeleteInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_deleteTeamMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipDeleteInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Superuser_DeleteTeamMembershipMutation, Superuser_DeleteTeamMembershipMutationVariables>;
export const Superuser_UpdateTeamMembershipStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_updateTeamMembershipStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "TeamMembershipUpdateStatusInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_updateTeamMembershipStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamMembershipUpdateStatusInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Superuser_UpdateTeamMembershipStatusMutation,
  Superuser_UpdateTeamMembershipStatusMutationVariables
>;
export const Superuser_TeamListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "superuser_teamListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_teamListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceId" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "logoType" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Superuser_TeamListForWorkspaceQuery, Superuser_TeamListForWorkspaceQueryVariables>;
export const Superuser_CreateTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_createTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreateTeamInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_createTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createTeamInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "logoType" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "username" } },
                            { kind: "Field", name: { kind: "Name", value: "fullname" } },
                            { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Superuser_CreateTeamMutation, Superuser_CreateTeamMutationVariables>;
export const GetUnitListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUnitList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GetUnitListInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unitList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getUnitListInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "symbol" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUnitListQuery, GetUnitListQueryVariables>;
export const GetUnitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUnit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GetUnitInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getUnitInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "symbol" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUnitQuery, GetUnitQueryVariables>;
export const CreateUnitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createUnit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreateUnitInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUnit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createUnitInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "symbol" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUnitMutation, CreateUnitMutationVariables>;
export const UpdateUnitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUnit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateUnitInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUnit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateUnitInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "symbol" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUnitMutation, UpdateUnitMutationVariables>;
export const DeleteUnitDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUnit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DeleteUnitInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUnit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteUnitInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "symbol" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUnitMutation, DeleteUnitMutationVariables>;
export const AssigneeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Assignee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GetAssigneeInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getAssigneeInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssigneeQuery, AssigneeQueryVariables>;
export const AssigneeByOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AssigneeByOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetAssigneeListByOwnerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assigneeByOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getAssigneeListByOwnerInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssigneeByOwnerQuery, AssigneeByOwnerQueryVariables>;
export const CreateAssigneeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createAssignee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateAssigneeInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createAssignee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createAssigneeInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAssigneeMutation, CreateAssigneeMutationVariables>;
export const UpdateAssigneeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateAssignee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateAssigneeInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAssignee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateAssigneeInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAssigneeMutation, UpdateAssigneeMutationVariables>;
export const DeleteAssigneeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteAssignee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DeleteAssigneeInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteAssignee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deleteAssigneeInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAssigneeMutation, DeleteAssigneeMutationVariables>;
export const GetUserFavoriteListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserFavoriteList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "getUserFavoriteListInput" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UserFavoriteGetInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserFavoriteList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getUserFavoriteListInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "getUserFavoriteListInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pageUrl" } },
                { kind: "Field", name: { kind: "Name", value: "pageName" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserFavoriteListQuery, GetUserFavoriteListQueryVariables>;
export const CreateUserFavoriteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateUserFavorite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UserFavoriteCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUserFavorite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userFavoriteCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pageUrl" } },
                { kind: "Field", name: { kind: "Name", value: "pageName" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserFavoriteMutation, CreateUserFavoriteMutationVariables>;
export const DeleteUserFavoriteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUserFavorite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UserFavoriteDeleteInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUserFavorite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userFavoriteDeleteInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pageUrl" } },
                { kind: "Field", name: { kind: "Name", value: "pageName" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserFavoriteMutation, DeleteUserFavoriteMutationVariables>;
export const RenameUserFavoriteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RenameUserFavorite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UserFavoriteRenameInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "renameUserFavorite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userFavoriteRenameInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "pageUrl" } },
                { kind: "Field", name: { kind: "Name", value: "pageName" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenameUserFavoriteMutation, RenameUserFavoriteMutationVariables>;
export const CurrentUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "currentUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                { kind: "Field", name: { kind: "Name", value: "superUser" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workspace" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "logo" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const UserInWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "userInWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserGetInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userInWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userGetInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workspace" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "logo" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserInWorkspaceQuery, UserInWorkspaceQueryVariables>;
export const UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UserUpdateInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userUpdateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdatePasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updatePassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "PasswordUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "passwordUpdateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "fullname" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const GetActiveViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActiveView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "GetActiveViewInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activeView" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "getActiveViewInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "showColumnHeaders" } },
                { kind: "Field", name: { kind: "Name", value: "sectionColumnId" } },
                { kind: "Field", name: { kind: "Name", value: "subSectionColumnId" } },
                { kind: "Field", name: { kind: "Name", value: "globalFilter" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "columnFilters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "columnOrder" } },
                { kind: "Field", name: { kind: "Name", value: "columnVisibility" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sorting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "desc" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "expanded" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActiveViewQuery, GetActiveViewQueryVariables>;
export const CreateActiveViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateActiveView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateActiveViewInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createActiveView" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "createActiveViewInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "showColumnHeaders" } },
                { kind: "Field", name: { kind: "Name", value: "sectionColumnId" } },
                { kind: "Field", name: { kind: "Name", value: "subSectionColumnId" } },
                { kind: "Field", name: { kind: "Name", value: "globalFilter" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "columnFilters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "columnOrder" } },
                { kind: "Field", name: { kind: "Name", value: "columnVisibility" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sorting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "desc" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "expanded" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateActiveViewMutation, CreateActiveViewMutationVariables>;
export const UpdateActiveViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateActiveView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateActiveViewInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateActiveView" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateActiveViewInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "key" } },
                { kind: "Field", name: { kind: "Name", value: "showColumnHeaders" } },
                { kind: "Field", name: { kind: "Name", value: "sectionColumnId" } },
                { kind: "Field", name: { kind: "Name", value: "subSectionColumnId" } },
                { kind: "Field", name: { kind: "Name", value: "globalFilter" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "columnFilters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "columnOrder" } },
                { kind: "Field", name: { kind: "Name", value: "columnVisibility" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sorting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "desc" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "expanded" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateActiveViewMutation, UpdateActiveViewMutationVariables>;
export const WorkspaceMembershipListForWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "workspaceMembershipListForWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "workspaceMembershipListForWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceId" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorkspaceMembershipListForWorkspaceQuery,
  WorkspaceMembershipListForWorkspaceQueryVariables
>;
export const FindWorkspaceInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "findWorkspaceInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "findWorkspaceInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                      { kind: "Field", name: { kind: "Name", value: "activated" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspace" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "logo" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindWorkspaceInviteQuery, FindWorkspaceInviteQueryVariables>;
export const UpdateWorkspaceMembershipRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateWorkspaceMembershipRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceMembershipUpdateRoleInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateWorkspaceMembershipRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceMembershipUpdateRoleInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWorkspaceMembershipRoleMutation, UpdateWorkspaceMembershipRoleMutationVariables>;
export const UpdateWorkspaceMembershipStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateWorkspaceMembershipStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceMembershipUpdateStatusInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateWorkspaceMembershipStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceMembershipUpdateStatusInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWorkspaceMembershipStatusMutation, UpdateWorkspaceMembershipStatusMutationVariables>;
export const LeaveWorkspaceMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "leaveWorkspaceMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceMembershipLeaveInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leaveWorkspaceMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceMembershipLeaveInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeaveWorkspaceMembershipMutation, LeaveWorkspaceMembershipMutationVariables>;
export const RejoinWorkspaceMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "rejoinWorkspaceMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceMembershipRejoinInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rejoinWorkspaceMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceMembershipRejoinInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RejoinWorkspaceMembershipMutation, RejoinWorkspaceMembershipMutationVariables>;
export const CreateWorkspaceInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createWorkspaceInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceInviteCreateWithEmailInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createWorkspaceInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceInviteCreateWithEmailInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateWorkspaceInviteMutation, CreateWorkspaceInviteMutationVariables>;
export const AcceptWorkspaceInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "acceptWorkspaceInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceInviteAcceptInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptWorkspaceInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceInviteAcceptInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                      { kind: "Field", name: { kind: "Name", value: "activated" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspace" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "logo" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptWorkspaceInviteMutation, AcceptWorkspaceInviteMutationVariables>;
export const DeleteWorkspaceInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteWorkspaceInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceInviteDeleteInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteWorkspaceInvitation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceInviteDeleteInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWorkspaceInviteMutation, DeleteWorkspaceInviteMutationVariables>;
export const ResendWorkspaceInviteNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resendWorkspaceInviteNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceInviteUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resendWorkspaceInviteNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceInviteUpdateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResendWorkspaceInviteNotificationMutation,
  ResendWorkspaceInviteNotificationMutationVariables
>;
export const WorkspaceByUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "workspaceByUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "workspaceByUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceUrl" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyResults" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusAreaList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelGroupList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "labelList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeViewList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "showColumnHeaders" } },
                      { kind: "Field", name: { kind: "Name", value: "sectionColumnId" } },
                      { kind: "Field", name: { kind: "Name", value: "subSectionColumnId" } },
                      { kind: "Field", name: { kind: "Name", value: "globalFilter" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnFilters" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "columnOrder" } },
                      { kind: "Field", name: { kind: "Name", value: "columnVisibility" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sorting" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "desc" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "expanded" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceByUrlQuery, WorkspaceByUrlQueryVariables>;
export const WorkspaceByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "workspaceById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "workspaceById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceId" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyResults" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusAreaList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelGroupList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "labelList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                            { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeViewList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "showColumnHeaders" } },
                      { kind: "Field", name: { kind: "Name", value: "sectionColumnId" } },
                      { kind: "Field", name: { kind: "Name", value: "subSectionColumnId" } },
                      { kind: "Field", name: { kind: "Name", value: "globalFilter" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnFilters" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "columnOrder" } },
                      { kind: "Field", name: { kind: "Name", value: "columnVisibility" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sorting" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "desc" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "expanded" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkspaceByIdQuery, WorkspaceByIdQueryVariables>;
export const UpdateWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceUpdateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyResults" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "focusAreaList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "labelGroupList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "allowMultiSelect" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "labelList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "color" } },
                            { kind: "Field", name: { kind: "Name", value: "labelGroupId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeViewList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "showColumnHeaders" } },
                      { kind: "Field", name: { kind: "Name", value: "sectionColumnId" } },
                      { kind: "Field", name: { kind: "Name", value: "subSectionColumnId" } },
                      { kind: "Field", name: { kind: "Name", value: "globalFilter" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnFilters" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "columnOrder" } },
                      { kind: "Field", name: { kind: "Name", value: "columnVisibility" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sorting" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "desc" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "expanded" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;
export const DeleteWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceDeleteInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceDeleteInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;
export const SendWorkspaceDeleteCodeEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendWorkspaceDeleteCodeEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceDeleteCodeCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendWorkspaceDeleteCodeEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceDeleteCodeCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendWorkspaceDeleteCodeEmailMutation, SendWorkspaceDeleteCodeEmailMutationVariables>;
export const Superuser_DeleteWorkspaceMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_deleteWorkspaceMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceMembershipDeleteInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_deleteWorkspaceMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceMembershipDeleteInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Superuser_DeleteWorkspaceMembershipMutation,
  Superuser_DeleteWorkspaceMembershipMutationVariables
>;
export const Superuser_CreateWorkspaceMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_createWorkspaceMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceMembershipCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_createWorkspaceMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceMembershipCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "username" } },
                      { kind: "Field", name: { kind: "Name", value: "fullname" } },
                      { kind: "Field", name: { kind: "Name", value: "profilePicture" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Superuser_CreateWorkspaceMembershipMutation,
  Superuser_CreateWorkspaceMembershipMutationVariables
>;
export const Superuser_WorkspaceListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "superuser_workspaceList" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_workspaceList" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Superuser_WorkspaceListQuery, Superuser_WorkspaceListQueryVariables>;
export const Superuser_CreateWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_createWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_createWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceCreateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unitList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "symbol" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyResults" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "climateActionId" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Superuser_CreateWorkspaceMutation, Superuser_CreateWorkspaceMutationVariables>;
export const Superuser_DuplicateWorkspaceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "superuser_duplicateWorkspace" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "WorkspaceDuplicateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "superuser_duplicateWorkspace" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "workspaceDuplicateInput" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "workspaceUrl" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workspaceMembershipList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "userId" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phaseList" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "workspaceId" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instanceList" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Superuser_DuplicateWorkspaceMutation, Superuser_DuplicateWorkspaceMutationVariables>;
